/* NSI wishlist + back-in-stock 'Notify me' (19 Oct 2026, kit inhouse-swatches-2026-10/wishlist/; Andrew chose 'Best':
   our own wishlist in the theme + our own Klaviyo back-in-stock sign-up. Account sync and price drop are phase 2).

   Saved items live in THIS browser only: localStorage 'nsi_wl_v2' = {v:2, items:[{h: handle, p: product id,
   v: variant id or null, t: saved at (ms), n: name, vn: option name, pr: price in dollars, i: image URL}]}, newest
   first, at most 200 entries (the oldest drops off).
   A NEW KEY since the fix round (21 Oct 2026; the variant probe's P1): the 20 Oct script keeps one entry per product,
   so if it ever ran again (a tab opened before the 28 Oct push, or a rollback to the 20 Oct build) its first write
   would cut every extra shade out of a shared list. It reads and writes only 'nsi_wl_v1' ({v:1, items}), and this
   script never writes, changes or removes v1: while a browser has no v2 yet, it reads v1 and copies it into v2 ONCE
   (the first page view). So a rollback shows the pre-release list, and re-pushing this build brings v2 back.
   EACH SAVED OPTION IS ITS OWN ENTRY (21 Oct 2026, Andrew: "Best: save every shade or size separately, like Swym
   did"; the kit's VARIANT-WISHLIST-SPEC.md): an entry is keyed (p, v), so saving 002, 005 and 013 of HEMA 1-100 gives
   3 entries. v null is the product as a whole (a card heart saves that). Saving one of its options replaces it, so a
   product never has both (clean() keeps it that way, with no duplicate card). Lists saved before 21 Oct held one entry
   per product, each already one (p, v), so they carry over untouched; clean() keeps the newest of any exact duplicates.
   n/vn/pr/i (20 Oct 2026) are what the wishlist emails show for each item: taken when it is saved, refreshed from its
   server card on the wishlist page (a saved option's photo is its own), each one optional (older entries have none
   until the wishlist page has shown them) and checked on every read. They are sent to Klaviyo; the only one ever
   written into the page is i, as a saved option's photo when its product's .js can't be read (wishlist page below).
   Every storage access is wrapped in try/catch; with storage blocked the hearts still work for the page view.
   Other tabs follow through the 'storage' event, and a page restored from the back/forward cache re-reads the list
   ('pageshow' with persisted).

   - Header: a.nsi-wl-header (sections/static-basic-header.liquid) links to the wishlist page; its count bubble is
     [data-nsi-wl-count] (never .cart-count / [data-cart-count] / [data-header-cart-count]: assets/nsi-cart-drawer.js
     rewrites those with the CART quantity) and shows the number of ENTRIES. An inline script in the header paints the
     count and a 'saved' style (#nsi-wl-pre) before this deferred file runs: card hearts for any entry of their product,
     the product page button only for its own option (its data-nsi-wl-v); this file takes over and removes #nsi-wl-pre.
   - Hearts: every [data-nsi-wl-toggle], one delegated click listener, aria-pressed kept right, and a MutationObserver
     on the main content repaints cards that Load more / filter / sort add or replace.
     Card hearts (collection/search: snippets/nsi-wishlist-card.liquid) are filled when ANY entry of their product is
     saved. Empty, a tap saves the product (v null). Filled, a tap removes ALL its entries; the toast names the count
     ('Removed 3 saved options') and offers Undo, which puts them back exactly (same entries, times and order). A tap
     on that heart while its Undo shows (a second tap, an Android double tap) IS that Undo: it never saves the product
     as a whole over the removed shades (CR1, fix round 21 Oct 2026). Card hearts keep ONE accessible name, 'Save to
     wishlist', and aria-pressed carries the state (Andrew 20 Oct 2026, D7).
     The toast (CR2, fix round 21 Oct 2026): after a keyboard tap (Enter or Space) of a filled card heart, focus moves
     to Undo; while Undo is offered the countdown pauses while a mouse is over the toast or focus is in it (WCAG
     2.2.1). Any other toast ('Restored', 'Saved ...') keeps its own time, whatever the mouse or focus does (FX6,
     round 3: a resting mouse no longer holds it). Escape or Tab hands
     focus back to the heart, and a closed toast is emptied once it has faded, so nothing in it can be reached or read.
     The live region itself stays in place (hiding it would stop screen readers announcing the next message).
   - Product page (snippets/nsi-wishlist-pdp.liquid): the button follows the picked option. Its data-nsi-wl-v is the
     selected variant (printed by the server, then kept up to date on every option change: native change on
     select[name=id], the theme's jQuery 'shopify-variants:switch-variant' and our 'nsi:variant-price'); it reads 'Save
     to wishlist' / 'Saved to wishlist' for that option only, and a tap adds or removes only that option. The toast
     names it ('Saved 002 (Black) to your wishlist'; a bare number as 'Saved colour 005 to your wishlist', see
     NAME_NUMBERS). A product with one option has no data-nsi-wl-v: its button stands
     for the product, like a card heart (any entry = saved). Named by its visible text.
     The repeat-view nudge (round 3; Andrew 21 Oct 2026, "approved great idea", decisions.md): on a shopper's 3rd visit
     to the same product on this device (a visit counts only when it is 30+ minutes after the previous one), a line
     under the button: 'Keep coming back to this one? Save it to your wishlist.' A real button, named by that text.
     One tap saves the CURRENT option exactly as the Save button does (same events, same toast), plus GA4
     'nsi_wl_nudge_saved'. Never shown while the current option (or the product as a whole) is saved, and hidden for
     the rest of the page view once the shopper has used the Save button or the nudge. No layout jump: the header's
     first-paint script decides before the product form is parsed and reserves the line's box for the whole page
     view; after that only its visibility changes. GA4 'nsi_wl_nudge_shown' once per page view, the first time it is
     visible and at least half on screen. Both are normal GA4 events (never key events). Visits live in localStorage
     'nsi_wl_seen_v1' ({v:1, p:{<product id>: [visit times]}}): at most 3 times per product, 50 products, 30 days.
     Round 4 (RV3-2, 22 Oct 2026): 'shown' happens on a plain page view, so it goes to dataLayer at once but to gtag only
     once Google's tag is already loaded (a save, Notify me or nsi-nav-track's first menu click loaded it), else at the
     page view's first pointerdown or keydown: a page view alone never loads gtag.js (nsi-nav-track's rule).
     Round 4 (RV3-1): the header's first-paint script gives the line no box at all for a product saved as a whole, or
     for a one-option product that is saved, since the line can never show there (no blank gap under 'Saved').
     Round 5 (R4-1, Andrew 22 Oct 2026 "yes do this"): no box either while the option on show is a saved one, or when
     every option is saved; the accepted catch: a later pick of an unsaved option in that view shows no line (the
     Save button still saves it). P3-3: the line stays invisible until this script turns it on, so with ?nsi_wl=0 or a
     failed load no dead line shows (its box stays, nothing moves).
     'Notify me' (back in stock) shows for a sold-out variant (tracked, deny, not available), follows variant changes
     (the same hooks), and posts to Klaviyo's client back-in-stock endpoint. Enter in its fields never submits the
     product form. Honeypot + per-browser throttle (1 per variant per day, 5 per hour, localStorage 'nsi_bis_v1').
     Round 5: on phones, the sticky Add to cart bar (snippets/product.liquid, [data-nsi-satc]) gets our own 'Notify me'
     button in place of its dead 'Sold out' one while Notify me shows (see 'the phone sticky bar' below); a tap jumps to
     the email field and focuses it, and never submits the form. Release 2b: the same jump from the 'Email me if it
     comes back' link on the stock line. GA4 'nsi_bis_jump' (from: sticky / stock_line), a normal event.
   - Wishlist page (sections/nsi-wishlist.liquid): one card per entry, each the theme's own server-rendered card from
     /products/<handle>?view=_recently-viewed (trade prices, badges, hover photo), 4 entries at a time; entries of one
     product share ONE fetch of its card (cached by handle). A saved option of a product with several shows its own
     photo (its featured_image from /products/<handle>.js, also fetched once per handle; else the i saved with it, from
     our own image hosts only: CR4), its option line ('002 (Black)', '1 Gallon · Sold out', a bare number as
     'Colour: 005') and links to ?variant=<v>.
     Its PRICE is that option's own (round 3, Andrew 21 Oct 2026 ~9:40pm): the card comes from the theme's option view
     /products/<handle>?variant=<v>&view=_nsi-wl-card (templates/product._nsi-wl-card.liquid), so the server prints that
     option's price, its own compare-at (only when genuinely reduced), no 'from', its own Sold out / Save badge and, for
     a trade member, the trade line from that same price (snippets/product-price.liquid), the way every collection card
     does. Options at the same price point (price, compare-at, stock, from the product's .js) share ONE fetch, so 100
     HEMA shades cost one card. If the view doesn't answer (its marker is missing: an older theme, a rollback, a stale
     tab), the product's own card from ?view=_recently-viewed is used, as before, and the entry is kept. Round 4: the
     same when the view fails outright (an error after its retries, or a 200 with no card in it: P3-2), and when the
     product's .js can't be read even after one retry on a 429 or 5xx (RV3-4): then ONE product card serves all its
     saved options (its 'from' figure, never wrong for trade), never one option view each.
     Remove removes that entry only. A 404 (deleted or unpublished product)
     drops out quietly. Keys on the page (slots, data attributes, the queue, remove buttons) are 'p' or 'p:v'.
     ?items=h1:v1,h2,h3:v3 (the wishlist emails' 'View my wishlist' link, so the list opens on any device; Andrew
     20 Oct 2026, D5): every entry is checked (a handle [a-z0-9-]{1,120}, optionally ':' and a variant id), invalid
     ones are dropped and at most 20 are taken, each entry once (two options of one handle are both kept). h:v is that
     option, h the product. An entry already saved here keeps its place (a plain handle counts as saved when any entry
     of it is); the new ones go first, in the link's order. Each new one is saved once its card has loaded (the card
     gives its product id; a variant that isn't the product's own is dropped, so it is saved as the product), so
     storage never holds an entry without its id. Then history.replaceState takes the parameter out of the address bar
     (it stays if storage is blocked, so a reload still shows the list, and since round 4 (KS3-2) if an entry's card
     could not be loaded (a 429 / 5xx after the retries), so a reload tries it again; since round 5 (RV4-1) the address
     then keeps ONLY those failed entries, so a reload never re-adds an entry already merged, and perhaps removed by the
     shopper since). Merging sends no events. Nothing from the
     parameter is written into the page except a handle and a variant id that passed the check
     (sections/nsi-wishlist.liquid's placeholder script uses the same check).
   - 'Email me my wishlist' (25 Oct 2026; Andrew 22 Oct, decisions.md 'Wishlist storage', "Second now"): a box on the
     wishlist page for guests Klaviyo doesn't know yet. sections/nsi-wishlist.liquid prints it and its placeholder
     script shows it before the first paint or not at all; this file only sends. Fix round (Andrew 25 Oct: asking for
     the link subscribes the shopper to news and offers, no tick-box; the line before 'Send link' says so): the
     WC | Newsletter sign-up first, then ONE Klaviyo event 'Requested Wishlist Link' (Items / ItemCount / WishlistURL /
     WishlistItems). See the box's own section below.
     27 Oct 2026 (Andrew, decisions.md 27 Oct: the link email shows their saved items from Klaviyo's catalogue, whose
     lookups skip the WHOLE email when one meets an item that can't be bought): the box's Items carry ONLY the entries
     this page view has seen live and in stock (stock[], read from the cards the page loads anyway); ItemCount and
     WishlistItems stay the whole list. The 'Added to Wishlist' / 'Removed from Wishlist' events are unchanged.
     Round 7b (27 Oct 2026; the independent review of the Klaviyo draft 'NSI | Wishlist link', RV-1 and RV-2): an
     entry counts as in stock only if its product also has an option Klaviyo's catalogue counts as in stock (a variant
     Shopify sells only because its stock isn't tracked, with 'continue selling' off and a quantity at or below zero,
     is sold out to the catalogue: the card's data marks it nsi_k 0), and Items hold ONE entry per product, the newest
     that can be bought (the email looks its items up by product). Round 7c (27 Oct 2026; the independent review of
     track K, K-RV-3): what a card says about stock is as old as the card's own fetch, so a card the page re-places
     from its cache (another tab removed and re-added the entry, or saved another option of the product) keeps the
     time it was fetched, and after STOCK_MS it no longer counts.
   - 'Share my wishlist' (27 Oct 2026; Andrew, decisions.md 27 Oct: "have it as a button on the website wishlist page
     ... when they click it, it copys that long link they can email it or text it to someone"): a button on the
     wishlist page that copies the list's link (shareUrl(), exactly the box's WishlistURL) to the clipboard and says
     'Link copied' in the kit's toast. No Klaviyo, no GA4, no storage, no request. See its own section below.
   - Events: Klaviyo 'Added to Wishlist' / 'Removed from Wishlist' with the Added to Cart property names Well Copy's
     cart block reads ('Product Name', ImageURL, URL, Price ...) for the entry just saved or removed (with 'Variant
     Name' and VariantID), plus (20 Oct 2026) Items: the wishlist as it now is, newest first, up to 10, each
     {ProductName, VariantName, Price, ImageURL, URL, ProductID, VariantID}; ItemCount (entries); and WishlistURL:
     https://www.nsinails.com.au/pages/wishlist?items=<the 20 newest as handle or handle:variant, comma-separated,
     URL-encoded>. One event per tap: a card heart's remove-all sends one 'Removed from Wishlist' (for the newest of
     the entries it removed) and its Undo one 'Added to Wishlist' (the newest put back). Logged in: POST /client/events
     with the customer's email (klaviyo.identify is NEVER called). Guest: klaviyo.track (Klaviyo backfills it if the
     visitor is identified within 14 days). Never both. GA4: add_to_wishlist (item_variant) and nsi_notify_me the way
     snippets/nsi-nav-track.liquid sends; Undo sends no GA4 event (nothing new was saved).
     Images sent to Klaviyo (ImageURL and every Items[].ImageURL), and the i stored with an entry, come from our own
     image hosts only, the same check the wishlist page uses for photos (FX5, round 3): Shopify's CDN, or the store's
     /cdn/shop/ on www.nsinails.com.au or this page's host. Anything else is sent as ''. Since round 4 (P3-1 / RV3-5) the
     path is judged as the browser resolves it (new URL(...).pathname), and any '..' or '%2e' in it is refused.
   No dependencies, no third-party script. State for checks: window.NSIWishlist.info().
   Off: ?nsi_wl=0 (this page view only), nsi_wl_on in snippets/nsi-wishlist-config.liquid (everything),
   deploy.py rollback (puts the theme back). Saved lists stay in the browser either way (kit README, rollback). */
(function () {
  'use strict';
  if (window.NSIWishlist) return;
  var W = window, D = document;
  /* KEY: the list. V1_KEY: the 20 Oct list, only ever READ (until this browser has a v2 list) and copied once */
  var KEY = 'nsi_wl_v2', V1_KEY = 'nsi_wl_v1', BIS_KEY = 'nsi_bis_v1', MAX = 200, DAY = 864e5, HOUR = 36e5, BIS_PER_HOUR = 5, CAP = 4;
  /* the repeat-view nudge's visit log (round 3): a visit counts 30+ min after the previous one; at most 3 times per
     product, the 50 most recently visited products, 30 days. The header's first-paint script reads the same key with
     the same numbers and decides the 3rd visit (build.py checks both) */
  var SEEN_KEY = 'nsi_wl_seen_v1', SEEN_GAP = 18e5, SEEN_PER = 3, SEEN_MAX = 50, SEEN_DAYS = 30;
  /* the wishlist page's card for one saved option (round 3): templates/product._nsi-wl-card.liquid */
  var CARD_VIEW = '_nsi-wl-card';
  var KL_COMPANY = 'UjdYnM', KL_REV = '2025-10-15', KL_BASE = 'https://a.klaviyo.com/client/';
  var GA4 = 'G-66JZX7E5WX';
  /* WishlistURL, the emails' 'View my wishlist' link: always the launch address (Andrew 20 Oct 2026, D2), whichever
     address the page that sent the event had. The header, the toast and the account tile use the config snippet's. */
  var WL_PUBLIC = 'https://www.nsinails.com.au/pages/wishlist';
  var LINK_MAX = 20, EV_MAX = 10, SAFE = 9007199254740991;   /* ?items= entries; an event's Items; the largest safe id */
  /* how long a card heart's 'Removed ... · Undo' toast stays, any other toast, and the least time left once a mouse or
     focus leaves a paused toast (CR2) */
  var UNDO_MS = 6000, TOAST_MS = 3200, RESUME_MS = 2000;
  /* Andrew's call 2 (21 Oct 2026, recommended Best): an option whose whole value is a number ('005') is named on the
     wishlist page's card ('Colour: 005') and in the product page's toast ('Saved colour 005 to your wishlist'), for a
     product with one option. Every other option text, and everything sent to Klaviyo and GA4, stays as it is.
     false = the plain '005' everywhere, exactly the 21 Oct build's wording (no re-test needed to switch it off). */
  var NAME_NUMBERS = true;
  /* one ?items= entry: a handle, then optionally ':' and a variant id. sections/nsi-wishlist.liquid's placeholder
     script uses the very same pattern (build.py checks both). */
  var ITEM = /^([a-z0-9-]{1,120})(?::([1-9]\d{0,15}))?$/;
  var T = {
    header: 'Wishlist', headerN: ' saved',
    save: 'Save to wishlist', saved: 'Saved to wishlist',
    toastSaved: 'Saved to your wishlist', toastRemoved: 'Removed from your wishlist', view: 'View',
    savedOpt: ['Saved ', ' to your wishlist'], removedN: ['Removed ', ' saved options'],
    restoredN: ['Restored ', ' saved options'], undo: 'Undo',
    bisOk: "Thanks, we'll email you if it comes back in stock.",
    bis404a: "Sorry, we can't set up an alert for this one. Please ", bis404b: 'contact us', bis404c: " and we'll let you know.",
    bisErr: 'Sorry, something went wrong. Please try again.',
    bisBad: 'Please enter a valid email.',
    bisHour: "You've set up a few alerts already. Please try again in an hour.",
    satcNotify: 'Notify me',
    /* the 'Email me my wishlist' box (25 Oct 2026): its status line under the field (the line before 'Send link' always
       stays), each at most 60 characters. mailOk is Andrew's sent message: build.py writes it in from BOX-COPY.json,
       the one source of the box's words; the section holds a hidden copy of each, so the line is as tall as the tallest */
    mailBusy: 'Sending…', mailOk: "Sent! Check your inbox for your wishlist link.",
    mailBad: 'Please enter a valid email.', mailBad2: 'Please check your email address and try again.',
    mailErr: 'Sorry, something went wrong. Please try again.', mailNet: "Couldn't send it. Check your connection and try again.",
    mailHour: "You've sent a few already. Please try again in an hour.", mailWait: 'Still loading your list. Please try again in a moment.',
    /* 'Share my wishlist' (27 Oct 2026): what the kit's toast says after a tap (the page's layout never moves for it) */
    shareOk: 'Link copied', shareManual: 'Copy the link below to share your wishlist.',
    shareWait: 'Still loading your list. Please try again in a moment.'
  };
  var log = [];
  function note(kind, data) { try { log.push({ kind: kind, at: Date.now(), data: data }); if (log.length > 80) log.shift(); } catch (e) {} }

  var css = D.querySelector('link[data-nsi-wl-css]');
  if (css && css.media !== 'all') css.media = 'all';   /* the non-critical styles (loaded as print, so never blocking) */

  if (/[?&]nsi_wl=0(?:&|$)/.test(location.search)) {
    W.NSIWishlist = { aside: true, info: function () { return { aside: true }; } };
    return;
  }

  /* ------------------------------------------------------------------ storage */
  function lsGet(k) { try { return W.localStorage.getItem(k); } catch (e) { return null; } }
  function lsSet(k, v) { try { W.localStorage.setItem(k, v); return true; } catch (e) { return false; } }
  function parse(s) { try { return s ? JSON.parse(s) : null; } catch (e) { return null; } }
  var HANDLE = /^(?!\.\.?$)[^\s\/?#"'<>\\]{1,255}$/;   /* never '.' or '..' (the URL would climb out of /products/) */
  function id(x) { var n = Math.floor(+x); return n > 0 && n <= SAFE ? n : 0; }
  /* an entry's key: 'p' (the product as a whole) or 'p:v' (one option). The wishlist page's placeholder script and
     the header's first-paint script build the same keys. */
  function ek(p, v) { return p + (v ? ':' + v : ''); }
  function byNewest(a, b) { return ((b && +b.t) || 0) - ((a && +a.t) || 0); }
  /* the email snapshot of an item (n, vn, pr, i), checked: copies the good fields of x onto o */
  function snap(x, o) {
    if (typeof x.n === 'string' && x.n.trim()) o.n = x.n.replace(/\s+/g, ' ').trim().slice(0, 200);
    if (typeof x.vn === 'string' && x.vn.trim()) o.vn = x.vn.replace(/\s+/g, ' ').trim().slice(0, 120);
    if (typeof x.pr === 'number' && isFinite(x.pr) && x.pr >= 0 && x.pr < 1e7) o.pr = Math.round(x.pr * 100) / 100;
    if (typeof x.i === 'string' && /^https:\/\/[^\s"'<>\\]{1,600}$/.test(x.i) && ownUrl(x.i)) o.i = x.i;   /* FX5: our own image hosts only */
    return o;
  }
  function clean(list) {
    var out = [], seen = {}, opt = {};
    (Array.isArray(list) ? list : []).slice().sort(byNewest).forEach(function (x) {
      if (!x || typeof x !== 'object') return;
      var p = id(x.p), v = x.v == null ? 0 : id(x.v), h = typeof x.h === 'string' ? x.h : '', k = 'k' + ek(p, v);
      if (!p || !HANDLE.test(h) || seen[k]) return;   /* newest first, so an exact duplicate keeps the newest */
      seen[k] = 1;
      if (v) opt['p' + p] = 1;
      out.push(snap(x, { h: h, p: p, v: v || null, t: +x.t > 0 ? +x.t : 0 }));
    });
    /* the product as a whole gives way to any saved option of it (no duplicate card); a list saved before 21 Oct
       (one entry per product) never has both, so it comes back unchanged */
    out = out.filter(function (x) { return x.v || !opt['p' + x.p]; });
    return out.length > MAX ? out.slice(0, MAX) : out;
  }
  function stored(k, ver) { var s = parse(lsGet(k)); return s && s.v === ver && Array.isArray(s.items) ? s.items : null; }
  /* the list in nsi_wl_v2; while this browser has none, the 20 Oct list (nsi_wl_v1) as it is */
  function read() { var a = stored(KEY, 2); if (a === null) a = stored(V1_KEY, 1); return a ? clean(a) : []; }
  var items = read();
  function persist() { return lsSet(KEY, JSON.stringify({ v: 2, items: items })); }   /* v2 only: v1 is never written */
  /* the one-time copy: a browser with a 20 Oct list and no v2 yet gets that list in v2 now. v1 stays exactly as it is,
     for the 20 Oct script (an old tab, or a rollback), which never reads v2 */
  var fromV1 = false;
  if (lsGet(KEY) === null && stored(V1_KEY, 1) !== null) fromV1 = persist();
  var persistTimer = 0;
  function persistSoon() { clearTimeout(persistTimer); persistTimer = setTimeout(persist, 300); }
  function entry(p, v) {   /* the saved entry (p, v); v empty = the product as a whole */
    p = +p; v = +v || 0;
    for (var i = 0; i < items.length; i++) if (items[i].p === p && (items[i].v || 0) === v) return items[i];
    return null;
  }
  function entriesOf(p) { p = +p; return items.filter(function (x) { return x.p === p; }); }   /* newest first */
  function byKey(k) { for (var i = 0; i < items.length; i++) if (ek(items[i].p, items[i].v) === k) return items[i]; return null; }
  /* a new entry, first in the list. The product as a whole only while none of its options is saved; an option then
     takes the product's own entry out (clean()) */
  function add(e) {
    var p = id(e && e.p), v = id(e && e.v);
    if (!p || !HANDLE.test((e && e.h) || '') || entry(p, v) || (!v && entriesOf(p).length)) return false;
    items = clean([snap(e, { h: e.h, p: p, v: v || null, t: Date.now() })].concat(items));
    persist(); changed(); return true;
  }
  function removeEntry(p, v) {   /* that entry only; returns it (or null) */
    var x = entry(p, v);
    if (!x) return null;
    items = items.filter(function (y) { return y !== x; });
    persist(); changed(); return x;
  }
  function removeAll(p) {   /* every entry of a product (a card heart); returns them, newest first, for Undo */
    var gone = entriesOf(p);
    if (!gone.length) return gone;
    items = items.filter(function (x) { return x.p !== +p; });
    persist(); changed(); return gone;
  }
  function restore(list) {   /* Undo: the same entries with their own times, so they go back to the same places */
    if (!list || !list.length) return false;
    items = clean(list.concat(items));
    persist(); changed(); return true;
  }
  function changed() {
    paintAll();
    pageRender();
    try { D.dispatchEvent(new CustomEvent('nsi:wishlist', { detail: { count: items.length } })); } catch (e) {}
  }
  W.addEventListener('storage', function (e) {
    if (e.key !== null && e.key !== KEY) return;
    items = read();
    paintAll(); pageRender();
  });
  /* back/forward cache (review 20 Oct 2026): a page restored by Back keeps the list it had when the shopper left it,
     and Safari may not replay the storage events it missed (Chrome does). Re-read it, so a restored page never shows
     stale hearts and its next tap never writes a stale list back over saves made on other pages. */
  W.addEventListener('pageshow', function (e) {
    if (!e || !e.persisted) return;
    items = read();
    paintAll(); pageRender();
  });
  /* round 3: a product page restored by Back is a view of that product too (the nudge's box stays as it was) */
  W.addEventListener('pageshow', function (e) { if (e && e.persisted && nudge) nudge.visits = seenVisit(nudge.p); });

  /* ------------------------------------------------------------------ painting */
  function paintCount(n) {
    var els = D.querySelectorAll('[data-nsi-wl-count]');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (n > 0) { var s = String(n); if (el.textContent !== s) el.textContent = s; if (el.hidden) el.hidden = false; }
      else { if (el.textContent) el.textContent = ''; if (!el.hidden) el.hidden = true; }
    }
    /* the bubble is aria-hidden, so the link's name carries the count: 'Wishlist' / 'Wishlist, 3 saved' */
    var links = D.querySelectorAll('a[data-nsi-wl-link]'), al = n > 0 ? T.header + ', ' + n + T.headerN : T.header;
    for (var j = 0; j < links.length; j++) if (links[j].getAttribute('aria-label') !== al) links[j].setAttribute('aria-label', al);
  }
  /* saved or not: a button with data-nsi-wl-v (the product page, a product with several options) for its option
     only; every other (card hearts, a product page with one option) for any entry of its product */
  function isSaved(b) {
    var p = attr(b, 'data-nsi-wl-p');
    return b.hasAttribute('data-nsi-wl-v') ? !!entry(p, attr(b, 'data-nsi-wl-v')) : entriesOf(p).length > 0;
  }
  /* the product page button follows the picked option: its data-nsi-wl-v is the form's variant */
  function pdpVariant(b) {
    var v = currentVariant(b.closest('form'));
    if (v && attr(b, 'data-nsi-wl-v') !== String(v)) b.setAttribute('data-nsi-wl-v', String(v));
  }
  function paintToggles(root) {
    var scope = root || D, list = [];
    if (scope.nodeType === 1 && scope.matches('[data-nsi-wl-toggle]')) list.push(scope);
    if (scope.querySelectorAll) list = list.concat([].slice.call(scope.querySelectorAll('[data-nsi-wl-toggle]')));
    for (var i = 0; i < list.length; i++) {
      var b = list[i];
      if (b.hasAttribute('data-nsi-wl-v')) pdpVariant(b);
      var want = isSaved(b) ? 'true' : 'false';
      if (b.getAttribute('aria-pressed') !== want) b.setAttribute('aria-pressed', want);
      /* a card heart's name never changes ('Save to wishlist'); aria-pressed says whether it is saved (Andrew
         20 Oct 2026, D7). The product-page button has no aria-label: its visible text names it. */
      if (b.classList.contains('nsi-wl-card') && b.getAttribute('aria-label') !== T.save) b.setAttribute('aria-label', T.save);
    }
  }
  function paintAll() {
    paintCount(items.length);
    paintToggles(D);
    paintNudge();   /* before the first-paint style goes: the nudge's own attribute then holds its box (round 3) */
    var pre = D.getElementById('nsi-wl-pre');   /* the header's first-paint style: our attributes say it now */
    if (pre && pre.parentNode) pre.parentNode.removeChild(pre);
  }
  function watchGrids() {
    if (!W.MutationObserver) return;
    var root = D.getElementById('site-main') || D.querySelector('main') || D.body;
    if (!root) return;
    if (!D.querySelector('.nsi-wl-card') && !/\btemplate-(collection|search)\b/.test(D.body.className)) return;
    new MutationObserver(function (recs) {
      for (var i = 0; i < recs.length; i++) {
        var added = recs[i].addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType === 1 && (n.matches('[data-nsi-wl-toggle]') || n.querySelector('[data-nsi-wl-toggle]'))) paintToggles(n);
        }
      }
    }).observe(root, { childList: true, subtree: true });
  }

  /* ------------------------------------------------------------------ helpers */
  function attr(el, a) { return (el && el.getAttribute(a)) || ''; }
  function num(x) { var n = parseFloat(x); return isFinite(n) ? Math.round(n * 100) / 100 : null; }
  function cents(x) { var n = parseFloat(x); return isFinite(n) && n > 0 ? Math.round(n) / 100 : null; }
  function abs(u) {
    u = String(u || '');
    if (!u) return '';
    if (u.indexOf('//') === 0) return 'https:' + u;
    if (u.charAt(0) === '/') return location.origin + u;
    return u;
  }
  function sized(u) {   /* a Shopify CDN image at 600px wide for emails (cards already pass one) */
    u = abs(u);
    if (!u || u.indexOf('/cdn/shop/') === -1 || /[?&]width=/.test(u)) return u;
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=600';
  }
  function productUrl(h, v) { return location.origin + '/products/' + encodeURIComponent(h) + (v ? '?variant=' + v : ''); }
  function wishlistUrl() { var a = D.querySelector('a[data-nsi-wl-link]'); return a ? a.getAttribute('href') : ''; }
  function customerEmail() {
    var el = D.querySelector('input[data-nsi-wl-email]');
    var e = el && el.value ? String(el.value).trim() : '';
    return /^[^\s@]+@[^\s@]+$/.test(e) ? e : '';
  }
  function source() {
    var c = D.body ? D.body.className : '';
    return /\btemplate-search\b/.test(c) ? 'Search card' : (/\btemplate-collection\b/.test(c) ? 'Collection card' : 'Card');
  }
  var pj = null;
  function productJson() {
    if (pj !== null) return pj || null;
    pj = false;
    try {
      var s = D.querySelector('script[data-section-type="static-product"][data-section-data]');
      var d = s && JSON.parse(s.textContent);
      if (d && d.product && d.product.variants) pj = d.product;
    } catch (e) { pj = false; }
    return pj || null;
  }
  function variantOf(P, id) {
    if (!P || !id) return null;
    for (var i = 0; i < P.variants.length; i++) if (+P.variants[i].id === +id) return P.variants[i];
    return null;
  }
  function currentVariant(form) {
    var el = form && (form.querySelector('select[name="id"]') || form.querySelector('input[name="id"]'));
    var v = el ? Math.floor(+el.value) : 0;
    return v > 0 ? v : 0;
  }
  /* the name of a product's one option ('Colour'), or '' (several options, none, or the default 'Title'). The page's
     product JSON lists names; /products/<handle>.js lists {name, position, values} */
  function optName(P) {
    var o = P && P.options;
    if (!Array.isArray(o) || o.length !== 1) return '';
    var n = typeof o[0] === 'string' ? o[0] : (o[0] && typeof o[0].name === 'string' ? o[0].name : '');
    n = n.replace(/\s+/g, ' ').trim();
    return n.length <= 40 && n !== 'Title' ? n : '';
  }
  /* Andrew's call 2 (NAME_NUMBERS): a bare-number option value ('005') with its option's name */
  function numbered(vt, name) { return !!(NAME_NUMBERS && name && /^\d{1,6}$/.test(vt || '')); }
  function optLine(vt, name) { return numbered(vt, name) ? name + ': ' + vt : vt; }                  /* 'Colour: 005' */
  function optToast(vt, name) { return numbered(vt, name) ? name.toLowerCase() + ' ' + vt : vt; }    /* 'colour 005' */

  /* ------------------------------------------------------------------ what was saved (for the events) */
  function cardInfo(b) {
    var h = attr(b, 'data-nsi-wl-h'), p = +attr(b, 'data-nsi-wl-p');
    var pr = +attr(b, 'data-nsi-wl-pr') || 0, c = +attr(b, 'data-nsi-wl-c') || 0;
    return { src: source(), h: h, p: p, v: null, title: attr(b, 'data-nsi-wl-t') || attr(b, 'data-nsi-wl-label'), vt: '',
             sku: attr(b, 'data-nsi-wl-s'), price: cents(pr), compare: c > pr ? cents(c) : null,
             img: abs(attr(b, 'data-nsi-wl-i')), url: productUrl(h), brand: attr(b, 'data-nsi-wl-b'), cats: null, type: '' };
  }
  function pdpInfo(wrap) {
    var form = wrap.closest('form'), P = productJson(), btn = wrap.querySelector('[data-nsi-wl-toggle]');
    var vid = currentVariant(form) || id(attr(btn, 'data-nsi-wl-v')), v = variantOf(P, vid);
    var many = P ? P.variants.length > 1 : false;
    var h = attr(wrap, 'data-nsi-wl-h'), cats = null;
    try { cats = JSON.parse(attr(wrap, 'data-nsi-wl-cats') || 'null'); } catch (e) { cats = null; }
    var img = v && v.featured_image && v.featured_image.src ? v.featured_image.src : attr(wrap, 'data-nsi-wl-i');
    return { src: 'Product page', h: h, p: +attr(btn, 'data-nsi-wl-p'), v: vid || null, on: many ? optName(P) : '',
             title: attr(wrap, 'data-nsi-wl-t') || (P && P.title) || '', vt: v && many ? String(v.title || '') : '',
             sku: v ? String(v.sku || '') : '', price: v ? cents(v.price) : null,
             compare: v && +v.compare_at_price > +v.price ? cents(v.compare_at_price) : null,
             img: sized(img), url: productUrl(h, many ? vid : 0), brand: attr(wrap, 'data-nsi-wl-b'),
             cats: Array.isArray(cats) ? cats.slice(0, 30) : null, type: attr(wrap, 'data-nsi-wl-ty') };
  }
  /* a stored entry as an event describes it (a card heart's remove-all, Undo), on top of what the card says: a saved
     option keeps its own name, price and photo as saved (the card's SKU and compare price are the product's) */
  function entryInfo(x, base) {
    var o = {}, k;
    for (k in base) o[k] = base[k];
    if (!x) return o;
    o.h = x.h; o.p = x.p; o.v = x.v || null;
    if (x.n) o.title = x.n;
    if (x.v) {
      o.vt = x.vn || ''; o.sku = ''; o.compare = null;
      o.price = typeof x.pr === 'number' ? x.pr : null;
      if (x.i) o.img = x.i;
    }
    o.url = productUrl(x.h, x.v && x.vn ? x.v : 0);
    return o;
  }
  function pageInfo(li, it) {
    var info = { src: 'Wishlist page', h: it ? it.h : '', p: it ? it.p : 0, v: it ? it.v : null, title: '', vt: '', sku: '',
                 price: null, compare: null, img: '', url: it ? productUrl(it.h, it.v) : '', brand: '', cats: null, type: '' };
    if (!li) return info;
    var t = li.querySelector('.productitem--title a');
    info.title = t ? t.textContent.replace(/\s+/g, ' ').trim() : '';
    info.img = cardImage(li);
    var data = cardJson(li);
    if (data) {
      var vs = data.variants || [], pick = null;
      for (var i = 0; i < vs.length; i++) if (it && it.v && +vs[i].id === +it.v) pick = vs[i];
      if (!pick) for (i = 0; i < vs.length && !pick; i++) if (vs[i].available) pick = vs[i];
      pick = pick || vs[0];
      if (pick) { info.price = cents(pick.price); if (it && it.v && vs.length > 1) info.vt = variantTitle(pick); }
    }
    return info;
  }
  function cardJson(li) { var s = li && li.querySelector('script[data-product-data]'); return s ? parse(s.textContent) : null; }
  function variantTitle(v) { return [v.option1, v.option2, v.option3].filter(function (x) { return x; }).join(' / '); }
  function cardImage(li) {   /* the card's main photo at 600px for emails (its rimg template), else what it shows */
    var img = li && li.querySelector('img.productitem--image-primary');
    if (!img) return '';
    var tpl = img.getAttribute('data-rimg-template') || '';
    if (tpl.indexOf('{size}') !== -1) return abs(tpl.replace('{size}', '600x600'));
    return sized(img.currentSrc || img.getAttribute('src') || '');
  }
  function cardId(li) {   /* the card's own product id (the Judge.me badge's data-id), or 0 */
    var jd = li && li.querySelector('.jdgm-widget[data-id]'), s = jd ? jd.getAttribute('data-id') : '';
    return /^\d{1,16}$/.test(s) ? id(s) : 0;
  }
  function manyHas(li, v) {   /* the card's product has several options and v is one of them */
    var vs = ((cardJson(li) || {}).variants) || [];
    if (!v || vs.length < 2) return false;
    for (var i = 0; i < vs.length; i++) if (+vs[i].id === +v) return true;
    return false;
  }
  /* an item's email snapshot read from its server-rendered card: the saved option's price and name, or (nothing
     saved) the card's own 'from' price, which is the lowest variant price (snippets/nsi-price-anchor.liquid) */
  function cardSnap(li, it) {
    var o = { n: '', vn: '', pr: null, i: cardImage(li), exact: false };
    var t = li && li.querySelector('.productitem--title a');
    if (t) o.n = t.textContent.replace(/\s+/g, ' ').trim();
    var data = cardJson(li), vs = (data && data.variants) || [], pick = null, low = null;
    for (var i = 0; i < vs.length; i++) {
      if (it && it.v && +vs[i].id === +it.v) pick = vs[i];
      var c = cents(vs[i].price);
      if (c !== null && (low === null || c < low)) low = c;
    }
    if (pick) {
      o.pr = cents(pick.price); o.exact = true;
      var vt = vs.length > 1 ? variantTitle(pick) : '';
      if (vt && vt !== 'Default Title') o.vn = vt;
    } else o.pr = low;
    return o;
  }
  /* bring a saved item's snapshot up to date from its card; the price only for a saved option, or when it had none */
  function refreshSnap(cur, s) {
    if (!cur || !s) return false;
    var ok = snap(s, {}), ch = false;
    if (ok.n && ok.n !== cur.n) { cur.n = ok.n; ch = true; }
    if (ok.i && ok.i !== cur.i) { cur.i = ok.i; ch = true; }
    if (ok.vn && ok.vn !== cur.vn) { cur.vn = ok.vn; ch = true; }
    if (ok.pr !== undefined && (s.exact || typeof cur.pr !== 'number') && ok.pr !== cur.pr) { cur.pr = ok.pr; ch = true; }
    return ch;
  }

  /* ------------------------------------------------------------------ Klaviyo + GA4 */
  function klPost(path, body, signal, keep) {
    var o = { method: 'POST', mode: 'cors', credentials: 'omit',
              headers: { 'revision': KL_REV, 'content-type': 'application/vnd.api+json' }, body: JSON.stringify(body) };
    if (signal) o.signal = signal;
    if (keep) o.keepalive = true;   /* an event survives the shopper tapping straight through to the product */
    return W.fetch(KL_BASE + path + '?company_id=' + KL_COMPANY, o);
  }
  function klProps(info) {
    var o = {
      'Product Name': info.title || '', ProductName: info.title || '', ProductID: info.p || null, VariantID: info.v || null,
      'Variant Name': info.vt || '', SKU: info.sku || '', Price: num(info.price), CompareAtPrice: num(info.compare),
      $value: num(info.price), Currency: 'AUD', ImageURL: ownUrl(info.img), URL: info.url || '', Brand: info.brand || '',
      Handle: info.h || '', Source: info.src || '', 'Wishlist Count': items.length,
      Items: evItems(), ItemCount: items.length, WishlistURL: shareUrl()   /* the whole wishlist, for the emails */
    };
    if (info.type) o['Product Type'] = info.type;
    if (info.cats && info.cats.length) o.Categories = info.cats;
    return o;
  }
  /* the wishlist as it is now (after this save or removal), newest first, for the emails' product grid. list (27 Oct
     2026): the box's own pick of entries instead (inStock(): only what can be bought now); the wishlist events give none */
  function evItems(list) {
    return (list || items).slice(0, EV_MAX).map(function (x) {
      return { ProductName: x.n || '', VariantName: x.vn || '', Price: typeof x.pr === 'number' ? x.pr : null,
               ImageURL: ownUrl(x.i), URL: productUrl(x.h, x.v && x.vn ? x.v : 0), ProductID: x.p, VariantID: x.v || null };
    });
  }
  /* 'View my wishlist': the launch address with the 20 newest as handle or handle:variant (the wishlist page reads it) */
  function shareUrl() {
    var t = [];
    for (var i = 0; i < items.length && t.length < LINK_MAX; i++) {
      var x = items[i];
      if (/^[a-z0-9-]{1,120}$/.test(x.h)) t.push(x.h + (x.v ? ':' + x.v : ''));
    }
    return WL_PUBLIC + (t.length ? '?items=' + encodeURIComponent(t.join(',')) : '');
  }
  function uid(name, p) { return 'nsiwl-' + (/^Added/.test(name) ? 'a' : 'r') + '-' + p + '-' + Date.now() + '-' + Math.random().toString(36).slice(2, 8); }
  function klaviyoEvent(name, info) {
    var props = klProps(info), email = customerEmail(), via = 'none';
    if (email) {
      /* logged in: straight onto the customer's profile; never klaviyo.identify (that would pull logged-in shoppers
         into Well Copy's browse and site abandonment flows, Andrew's and Well Copy's call for later) */
      var attrs = { properties: props, metric: { data: { type: 'metric', attributes: { name: name } } },
                    profile: { data: { type: 'profile', attributes: { email: email } } }, unique_id: uid(name, info.p) };
      if (props.$value !== null) attrs.value = props.$value;
      via = 'api';
      try { klPost('events/', { data: { type: 'event', attributes: attrs } }, null, true).catch(function () {}); } catch (e) {}
    } else {
      try { if (W.klaviyo && typeof W.klaviyo.track === 'function') { W.klaviyo.track(name, props); via = 'onsite'; } } catch (e) {}
    }
    note('klaviyo', { name: name, via: via, props: props });
    return via;
  }
  var gaReady = false;
  function gaIds() { var out = []; try { var g = W.google_tag_manager || {}; for (var k in g) if (k.indexOf('G-') === 0) out.push(k); } catch (e) {} return out; }
  function gaConfigure() {
    if (gaReady) return;
    gaReady = true;
    try {
      /* the store's GA4 runs in the NSI GA4 custom pixel's sandbox, so (like nsi-nav-track) we register our own gtag
         target for the same property, on the first event only; send_page_view:false = no double-counted page views */
      var have = false;
      try { have = !!(W.google_tag_manager && W.google_tag_manager[GA4]); } catch (e) {}
      if (!have && !D.querySelector('script[src*="gtag/js?id=' + GA4 + '"]')) {
        var s = D.createElement('script'); s.async = true; s.src = 'https://www.googletagmanager.com/gtag/js?id=' + GA4;
        (D.head || D.body).appendChild(s);
      }
      if (typeof W.gtag !== 'function') W.gtag = function () { W.dataLayer.push(arguments); };
      W.gtag('js', new Date());
      W.gtag('config', GA4, { send_page_view: false });
    } catch (e) {}
  }
  /* RV3-2 (round 4, 22 Oct 2026): a hit no shopper started (the nudge's 'shown', on a plain page view) never loads
     gtag.js by itself. It goes to dataLayer at once; its gtag call waits until Google's tag is already loaded (gaReady:
     a save or Notify me in this page view; or nsi-nav-track's tag from a menu click), else for the page view's first
     pointerdown or keydown, the way nsi-nav-track loads the tag on the first menu click, never on page load */
  var gaHeld = [], gaArmed = false;
  function gaLoaded() {
    if (gaReady) return true;
    try { if (W.google_tag_manager && W.google_tag_manager[GA4]) return true; } catch (e) {}
    try { return !!D.querySelector('script[src*="gtag/js?id=' + GA4 + '"]'); } catch (e) { return false; }
  }
  function gaSend(name, params) {
    try {
      gaConfigure();
      if (typeof W.gtag === 'function') {
        var ids = gaIds();
        if (ids.indexOf(GA4) === -1) ids.push(GA4);
        ids.forEach(function (id) { var q = {}; for (var k in params) q[k] = params[k]; q.send_to = id; W.gtag('event', name, q); });
      }
    } catch (e) {}
  }
  function gaFlush() {   /* held hits go first, in their order */
    var q = gaHeld;
    gaHeld = [];
    for (var i = 0; i < q.length; i++) { gaSend(q[i][0], q[i][1]); note('ga', { name: q[i][0], sent: 'held' }); }
  }
  function gaFirstInput() {
    gaArmed = false;
    try { D.removeEventListener('pointerdown', gaFirstInput, true); D.removeEventListener('keydown', gaFirstInput, true); } catch (e) {}
    gaFlush();
  }
  /* later: true for a hit that happens without the shopper doing anything (the nudge's 'shown') */
  function ga(name, params, later) {
    W.dataLayer = W.dataLayer || [];
    try { var o = { event: name }; for (var k in params) o[k] = params[k]; W.dataLayer.push(o); } catch (e) {}
    if (later && !gaLoaded()) {
      gaHeld.push([name, params]);
      if (!gaArmed) {
        gaArmed = true;
        try { D.addEventListener('pointerdown', gaFirstInput, true); D.addEventListener('keydown', gaFirstInput, true); } catch (e) {}
      }
      note('ga', { name: name, params: params, held: true });
      return;
    }
    gaFlush();
    gaSend(name, params);
    note('ga', { name: name, params: params });
  }

  /* ------------------------------------------------------------------ toast */
  /* undoWith: {list: the entries a card heart just removed, info, btn}. Undo is offered until the toast goes.
     from: the heart or button the toast is about (focus goes back to it). CR2 (fix round 21 Oct 2026): while Undo is
     offered (FX6, round 3: only then) the countdown
     pauses while a mouse (not a finger: phones keep :hover after a tap) is over the toast or focus is in it, and goes on
     with at least RESUME_MS once both have left; Escape closes it, and Tab from its Undo goes back to the heart; a
     closed toast is emptied once it has faded (nothing in it can be reached or read; the live region stays). */
  var toastEl = null, toastTimer = 0, toastLeft = 0, toastAt = 0, toastGen = 0, toastMouse = false, toastFrom = null, undoBox = null;
  /* held: only while Undo is offered (FX6, round 3). A 'Restored', 'Saved ...' or 'Removed ...' toast without Undo keeps
     its own time: the mouse that just clicked Undo usually rests on the toast, and must not keep it on screen */
  function toastHeld() { try { return !!undoBox && (toastMouse || !!(toastEl && toastEl.contains(D.activeElement))); } catch (e) { return false; } }
  function toastRun(ms) { clearTimeout(toastTimer); toastLeft = ms; toastAt = Date.now(); toastTimer = setTimeout(toastDue, ms); }
  function toastPause() {
    if (!toastTimer || !undoBox) return;
    clearTimeout(toastTimer); toastTimer = 0;
    toastLeft = Math.max(0, toastLeft - (Date.now() - toastAt));
  }
  function toastResume() {
    if (toastTimer || !toastEl || !toastEl.classList.contains('on') || toastHeld()) return;
    toastRun(Math.max(toastLeft, RESUME_MS));
  }
  function toastDue() { toastTimer = 0; toastLeft = 0; if (!toastHeld()) toastClose(); }
  function toastEmpty() { if (toastEl) while (toastEl.firstChild) toastEl.removeChild(toastEl.firstChild); }
  /* focus the heart a toast is about; if the grid was redrawn since (sort, filter), the same product's heart */
  function focusBack(b) {
    try {
      if (b && !b.isConnected) {
        var p = attr(b, 'data-nsi-wl-p');
        b = /^\d{1,20}$/.test(p) ? D.querySelector('.nsi-wl-card[data-nsi-wl-p="' + p + '"]') : null;
      }
      if (!b || !b.isConnected) return false;
      try { b.focus({ preventScroll: true }); } catch (e) { b.focus(); }
      return D.activeElement === b;
    } catch (e) { return false; }
  }
  function toastClose() {
    clearTimeout(toastTimer); toastTimer = 0; toastLeft = 0;
    undoBox = null;
    if (!toastEl) return;
    var from = toastFrom, inside = false, g = toastGen;
    try { inside = toastEl.contains(D.activeElement); } catch (e) {}
    toastFrom = null; toastMouse = false;
    toastEl.classList.remove('on');
    if (inside) focusBack(from);   /* never leave focus on something that is going */
    setTimeout(function () { if (g === toastGen && toastEl && !toastEl.classList.contains('on')) toastEmpty(); }, 300);   /* after the .22 s fade */
  }
  function toastKey(e) {
    var k = e && e.key;
    if (k === 'Escape' || k === 'Esc') { e.preventDefault(); toastClose(); return; }
    if (k === 'Tab' && undoBox && toastFrom && focusBack(toastFrom)) e.preventDefault();   /* back to the heart; Undo stays a while */
  }
  function toast(msg, link, undoWith, from) {
    try {
      if (!toastEl) {
        toastEl = D.createElement('div');
        toastEl.className = 'nsi-wl-toast';
        toastEl.setAttribute('role', 'status');
        toastEl.setAttribute('aria-live', 'polite');
        toastEl.addEventListener('pointerenter', function (e) { if (e.pointerType !== 'touch') { toastMouse = true; toastPause(); } });
        toastEl.addEventListener('pointerleave', function (e) { if (e.pointerType !== 'touch') { toastMouse = false; toastResume(); } });
        toastEl.addEventListener('focusin', toastPause);
        toastEl.addEventListener('focusout', function () { setTimeout(toastResume, 0); });   /* once focus has landed */
        toastEl.addEventListener('keydown', toastKey);
        D.body.appendChild(toastEl);
      }
      toastGen++;
      toastEmpty();
      var s = D.createElement('span'); s.id = 'nsi-wl-toast-msg'; s.textContent = msg; toastEl.appendChild(s);
      var url = link && wishlistUrl();
      if (url) { var a = D.createElement('a'); a.href = url; a.textContent = T.view; toastEl.appendChild(a); }
      undoBox = undoWith || null;
      toastFrom = from || (undoWith && undoWith.btn) || null;
      var u = null;
      if (undoWith) {
        u = D.createElement('button');
        u.type = 'button';
        u.setAttribute('data-nsi-wl-undo', '');
        u.setAttribute('aria-describedby', 'nsi-wl-toast-msg');   /* focused, it reads 'Undo, Removed 3 saved options' */
        u.textContent = T.undo;
        toastEl.appendChild(u);
      }
      toastEl.classList.add('on');
      toastRun(undoWith ? UNDO_MS : TOAST_MS);
      if (toastHeld()) toastPause();   /* the mouse is already on it (the Undo just clicked) */
      return u;
    } catch (e) { return null; }
  }
  /* Undo after a card heart's remove-all: the same entries back in their places, one 'Added to Wishlist' */
  function undo() {
    var u = undoBox;
    undoBox = null;
    if (!u || !restore(u.list)) return;
    var back = u.list.filter(function (x) { return !!entry(x.p, x.v); });
    klaviyoEvent('Added to Wishlist', entryInfo(back[0] || u.list[0], u.info));
    var refocus = !!(toastEl && toastEl.contains(D.activeElement)), n = u.list.length;
    toast(n > 1 ? T.restoredN[0] + n + T.restoredN[1] : T.toastSaved, true, null, u.btn);
    if (refocus) focusBack(u.btn);
  }

  /* ------------------------------------------------------------------ hearts */
  function save(info, v, b) {
    add({ h: info.h, p: info.p, v: v, n: info.title, vn: v ? info.vt : '', pr: info.price, i: info.img });
    klaviyoEvent('Added to Wishlist', info);
    ga('add_to_wishlist', { currency: 'AUD', value: num(info.price) || 0,
      items: [{ item_id: info.sku || String(info.v || info.p), item_name: info.title, item_variant: info.vt || '', price: num(info.price) || 0 }] });
    toast(v && info.vt ? T.savedOpt[0] + optToast(info.vt, info.on) + T.savedOpt[1] : T.toastSaved, true, null, b);
  }
  /* e: the click. A keyboard 'click' (Enter / Space) has detail 0: then focus follows to the Undo it offers (CR2) */
  function toggle(b, e) {
    var p = +attr(b, 'data-nsi-wl-p');
    if (!(p > 0)) return;
    var wrap = b.closest('[data-nsi-wl-pdp]');
    /* CR1 (fix round 21 Oct 2026): the card heart again while its Undo shows (a second tap, an Android double tap):
       that is the Undo, so the removed entries come back exactly; never a product-level save over them */
    if (!wrap && undoBox && undoBox.list.length && undoBox.list[0].p === p && !entriesOf(p).length) { undo(); return; }
    var info = wrap ? pdpInfo(wrap) : cardInfo(b);
    if (!info.h) return;
    info.p = p;
    if (wrap && nudge) nudge.done = true;   /* the shopper has used the button (or the nudge): no nudge for this view */
    if (wrap && b.hasAttribute('data-nsi-wl-v')) {   /* the product page: the picked option only */
      if (removeEntry(p, info.v)) {
        klaviyoEvent('Removed from Wishlist', info);
        toast(T.toastRemoved, false, null, b);
      } else save(info, info.v, b);
      return;
    }
    if (!entriesOf(p).length) { save(info, wrap ? info.v : null, b); return; }   /* a card heart saves the product */
    var gone = removeAll(p);
    if (wrap) {   /* the product page of a product with one option: as before, no Undo */
      klaviyoEvent('Removed from Wishlist', info);
      toast(T.toastRemoved, false, null, b);
      return;
    }
    /* a filled card heart: every entry of the product goes; one event, and Undo for a few seconds */
    klaviyoEvent('Removed from Wishlist', entryInfo(gone[0], info));
    var u = toast(gone.length > 1 ? T.removedN[0] + gone.length + T.removedN[1] : T.toastRemoved, false, { list: gone, info: info, btn: b }, b);
    if (u && e && e.detail === 0) { try { u.focus({ preventScroll: true }); } catch (x) { try { u.focus(); } catch (y) {} } }
  }

  /* ------------------------------------------------------------------ the repeat-view nudge (round 3) */
  /* The visit log: {v:1, p:{'<product id>': [visit times, oldest first]}}. Read, pruned (30 days, 3 per product, the
     50 most recently visited products) and written back on every product page view; a view counts as a visit only
     30+ min after the product's previous visit. Returns how many visits that product now has. */
  function seenVisit(p) {
    var s = parse(lsGet(SEEN_KEY)), src = s && s.v === 1 && s.p && typeof s.p === 'object' ? s.p : {};
    var now = Date.now(), keep = SEEN_DAYS * DAY, rows = [], mine = null, key = String(p);
    for (var k in src) {
      if (!/^\d{1,20}$/.test(k) || !Array.isArray(src[k])) continue;
      var ts = src[k].map(Number).filter(function (t) { return t > 0 && now - t < keep && t - now < DAY; })
        .sort(function (a, b) { return a - b; }).slice(-SEEN_PER);
      if (k === key) mine = [k, ts];
      else if (ts.length) rows.push([k, ts]);
    }
    mine = mine || [key, []];
    var last = mine[1].length ? mine[1][mine[1].length - 1] : 0;
    if (!last || now - last >= SEEN_GAP) mine[1] = mine[1].concat([now]).slice(-SEEN_PER);
    rows.push(mine);
    rows.sort(function (a, b) { return b[1][b[1].length - 1] - a[1][a[1].length - 1]; });
    var out = {};
    rows.slice(0, SEEN_MAX).forEach(function (r) { out[r[0]] = r[1]; });
    lsSet(SEEN_KEY, JSON.stringify({ v: 1, p: out }));
    return mine[1].length;
  }
  /* nudge: {el, btn, p, reserved, state 'on' | 'off', done (the shopper used the button or the nudge), sent (GA4
     shown), inView}. The header's first-paint script has already decided whether this view is a 3rd visit: if it
     reserved the line (displayed it), this script keeps that box for the whole page view and only changes its
     visibility; if it didn't, the nudge never shows on this view (it would push the page down) */
  var nudge = null;
  function nudgeInit() {
    var el = D.querySelector('[data-nsi-wl-pdp] [data-nsi-wl-nudge]'), wrap = el && el.closest('[data-nsi-wl-pdp]');
    var b = wrap && wrap.querySelector('[data-nsi-wl-toggle]'), p = id(attr(el, 'data-nsi-wl-p'));
    if (!b || !p || p !== id(attr(b, 'data-nsi-wl-p'))) return;
    var reserved = false;
    try { reserved = W.getComputedStyle(el).display !== 'none'; } catch (e) { reserved = false; }
    nudge = { el: el, btn: b, wrap: wrap, p: p, reserved: reserved, state: '', done: false, sent: false, inView: false, visits: seenVisit(p) };
    if (reserved && W.IntersectionObserver) {
      try {
        new W.IntersectionObserver(function (es) {
          for (var i = 0; i < es.length; i++) nudge.inView = es[i].isIntersecting && es[i].intersectionRatio >= 0.5;
          if (nudge.inView) nudgeShown();
        }, { threshold: [0, 0.5, 1] }).observe(el);
      } catch (e) { nudge.inView = true; }
    } else if (reserved) nudge.inView = true;
  }
  function paintNudge() {
    if (!nudge || !nudge.reserved) return;
    var el = nudge.el, b = nudge.btn, bv = attr(b, 'data-nsi-wl-v');
    if (bv && attr(el, 'data-nsi-wl-v') !== bv) el.setAttribute('data-nsi-wl-v', bv);
    /* off while the current option is saved, or the product as a whole (a card heart's save), or once used */
    var want = nudge.done || isSaved(b) || !!entry(nudge.p, 0) ? 'off' : 'on';
    if (el.getAttribute('data-nsi-wl-nudge') !== want) el.setAttribute('data-nsi-wl-nudge', want);
    nudge.state = want;
    if (want === 'on') nudgeShown();
  }
  function nudgeGa(wrap) {
    var info = pdpInfo(wrap);
    return { item_id: info.sku || String(info.v || info.p), item_name: info.title || '', item_variant: info.vt || '', visits: nudge ? nudge.visits : 0 };
  }
  /* GA4 'nsi_wl_nudge_shown', once per page view: the first time the line is visible and at least half on screen.
     Round 4 (RV3-2): dataLayer at once, gtag only once the tag is already loaded or the shopper first does something */
  function nudgeShown() {
    if (!nudge || nudge.sent || nudge.state !== 'on' || !nudge.inView) return;
    nudge.sent = true;
    ga('nsi_wl_nudge_shown', nudgeGa(nudge.wrap), true);
  }
  /* one tap saves the CURRENT option exactly as the Save button does (its events, its toast), then the line goes */
  function nudgeSave(nb, e) {
    if (!nudge || nudge.state !== 'on' || !nudge.wrap.contains(nb)) return;
    var sb = nudge.btn, had = D.activeElement === nb;
    if (attr(sb, 'data-nsi-wl-v')) pdpVariant(sb);   /* the option on show right now */
    if (!isSaved(sb)) {
      toggle(sb, e);   /* the Save button's own save: pdpInfo, the entry, Klaviyo, GA4 add_to_wishlist, the toast */
      if (isSaved(sb)) ga('nsi_wl_nudge_saved', nudgeGa(nudge.wrap));
    }
    nudge.done = true;
    paintNudge();
    if (had) { try { sb.focus({ preventScroll: true }); } catch (x) { try { sb.focus(); } catch (y) {} } }   /* never strand keyboard focus */
  }

  /* ------------------------------------------------------------------ Notify me (back in stock) */
  function bisState() {
    var s = parse(lsGet(BIS_KEY));
    if (!s || s.v !== 1 || typeof s.s !== 'object' || !Array.isArray(s.h)) s = { v: 1, s: {}, h: [] };
    var now = Date.now();
    s.h = s.h.filter(function (t) { return +t > 0 && now - t < HOUR; });
    for (var k in s.s) if (!(now - s.s[k] < DAY)) delete s.s[k];
    return s;
  }
  var bisMem = null;   /* storage blocked: throttle in memory for this page view */
  function bisLoad() { var s = bisState(); if (bisMem && !lsGet(BIS_KEY)) s = bisMem; return s; }
  function bisSave(s) { if (!lsSet(BIS_KEY, JSON.stringify(s))) bisMem = s; }
  function soldOut(vid, form) {
    var v = variantOf(productJson(), vid);
    if (v) return v.available === false && v.inventory_management === 'shopify';
    var o = form && form.querySelector('select[name="id"] option[value="' + vid + '"]');
    return !!(o && o.disabled);
  }
  function validEmail(e) { return e.length <= 254 && /^[^\s@<>()[\]\\,;:"]+@[^\s@<>()[\]\\,;:"]+\.[^\s@<>()[\]\\,;:".]{2,}$/.test(e); }
  function setMsg(blk, kind, text, contact) {
    var m = blk.querySelector('[data-nsi-bis-msg]');
    if (!m) return;
    while (m.firstChild) m.removeChild(m.firstChild);
    m.className = 'nsi-bis__msg' + (kind ? ' nsi-bis__msg--' + kind : '');
    if (contact) {
      m.appendChild(D.createTextNode(T.bis404a));
      var a = D.createElement('a'); a.href = '/pages/contact'; a.textContent = T.bis404b; m.appendChild(a);
      m.appendChild(D.createTextNode(T.bis404c));
    } else if (text) {
      m.appendChild(D.createTextNode(text));
    }
  }
  function bisReset(blk, vid) {
    var row = blk.querySelector('.nsi-bis__row'), input = blk.querySelector('[data-nsi-bis-email]');
    var done = !!bisLoad().s[vid];
    if (row && row.hidden !== done) row.hidden = done;
    if (input) input.removeAttribute('aria-invalid');
    setMsg(blk, done ? 'ok' : '', done ? T.bisOk : '');
  }
  function bisSync() {
    var wraps = D.querySelectorAll('[data-nsi-wl-pdp]');
    for (var i = 0; i < wraps.length; i++) {
      var wrap = wraps[i], blk = wrap.querySelector('[data-nsi-bis]');
      if (!blk) continue;
      var form = wrap.closest('form'), vid = currentVariant(form);
      if (blk.__vid === vid) continue;
      blk.__vid = vid;
      var out = !!vid && soldOut(vid, form);
      if (blk.hidden === out) blk.hidden = !out;
      if (out) bisReset(blk, vid);
    }
  }
  /* an option change: Notify me, and the Save button for the picked option */
  function onVariant() {
    bisSync();
    satcSync();   /* round 5: the phone sticky bar's Notify me follows Notify me */
    var wraps = D.querySelectorAll('[data-nsi-wl-pdp]');
    for (var i = 0; i < wraps.length; i++) paintToggles(wraps[i]);
    paintNudge();   /* the nudge follows the picked option too (its box stays) */
  }
  var syncTimer = 0;
  function scheduleSync() { clearTimeout(syncTimer); syncTimer = setTimeout(onVariant, 30); }
  function bisDone(blk, vid, sent) {
    if (blk.__vid === vid) {
      var row = blk.querySelector('.nsi-bis__row');
      if (row) row.hidden = true;
      setMsg(blk, 'ok', T.bisOk);
      satcSync();   /* round 5: signed up for this option: the sticky bar says 'Sold out' again */
    }
    if (sent) {
      var v = variantOf(productJson(), vid), P = productJson();
      ga('nsi_notify_me', { item_id: (v && v.sku) || String(vid), item_variant: v && P && P.variants.length > 1 ? String(v.title || '') : '' });
    }
  }
  function bisSubmit(blk) {
    if (!blk || blk.__busy || blk.hidden) return;
    var form = blk.closest('form'), vid = currentVariant(form);
    var input = blk.querySelector('[data-nsi-bis-email]'), hp = blk.querySelector('[data-nsi-bis-hp]');
    var btn = blk.querySelector('[data-nsi-bis-submit]');
    var email = input ? String(input.value || '').trim() : '';
    if (!validEmail(email)) {
      setMsg(blk, 'err', T.bisBad);
      if (input) { input.setAttribute('aria-invalid', 'true'); try { input.focus(); } catch (e) {} }
      return;
    }
    if (input) input.removeAttribute('aria-invalid');
    if (hp && hp.value) { note('bis', { vid: vid, honeypot: true }); bisDone(blk, vid, false); return; }   /* a bot: look done, send nothing */
    if (!vid || !soldOut(vid, form)) { setMsg(blk, 'err', T.bisErr); return; }
    var st = bisLoad();
    if (st.s[vid]) { note('bis', { vid: vid, repeat: true }); bisDone(blk, vid, false); return; }   /* already asked today */
    if (st.h.length >= BIS_PER_HOUR) { note('bis', { vid: vid, hourly: true }); setMsg(blk, 'err', T.bisHour); return; }
    st.h.push(Date.now()); bisSave(st);
    blk.__busy = true;
    if (btn) btn.disabled = true;
    blk.setAttribute('aria-busy', 'true');
    var body = { data: { type: 'back-in-stock-subscription',
      attributes: { profile: { data: { type: 'profile', attributes: { email: email } } }, channels: ['EMAIL'] },
      relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + vid } } } } };
    var ctl = W.AbortController ? new AbortController() : null, timer = ctl ? setTimeout(function () { ctl.abort(); }, 12000) : 0;
    var finish = function () {
      clearTimeout(timer); blk.__busy = false;
      if (btn) btn.disabled = false;
      blk.removeAttribute('aria-busy');
    };
    note('bis', { vid: vid, sent: true });
    var same = function () { return blk.__vid === vid; };
    klPost('back-in-stock-subscriptions/', body, ctl && ctl.signal).then(function (r) {
      finish();
      note('bis', { vid: vid, status: r.status });
      if (r.status >= 200 && r.status < 300) {
        var s2 = bisLoad(); s2.s[vid] = Date.now(); bisSave(s2);
        bisDone(blk, vid, true);
      } else if (same()) {
        if (r.status === 404) setMsg(blk, 'err', '', true);
        else setMsg(blk, 'err', T.bisErr);
      }
    }, function () {
      finish();
      note('bis', { vid: vid, status: 'network' });
      if (same()) setMsg(blk, 'err', T.bisErr);
    });
  }
  /* Enter in the email (or the hidden honeypot) runs Notify me and never submits the product form (implicit
     submission would click Add to cart). Capture phase, before any other listener. */
  function enterGuard(e) {
    if (e.key !== 'Enter' && e.keyCode !== 13) return;
    var t = e.target;
    if (!t || !t.closest || t.tagName !== 'INPUT') return;
    if (t.closest('[data-nsi-wl-mail]')) {   /* the wishlist page's 'Email me my wishlist' box (25 Oct 2026): Enter sends */
      e.preventDefault();
      if (e.type === 'keydown' && !e.repeat && !e.isComposing) mailSubmit();
      return;
    }
    var blk = t.closest('[data-nsi-bis]');
    if (!blk) return;
    e.preventDefault();
    e.stopPropagation();
    if (e.type === 'keydown' && !e.repeat) bisSubmit(blk);
  }
  D.addEventListener('keydown', enterGuard, true);
  D.addEventListener('keypress', enterGuard, true);

  /* ------------------------------------------------------------------ the phone sticky bar's Notify me (round 5) */
  /* snippets/product.liquid builds the phone sticky Add to cart bar ([data-nsi-satc], appended to body, phones only)
     after DOMContentLoaded. On a sold-out option its own button can only say 'Sold out' (disabled), beside a quantity
     stepper that still works (decisions.md 20 Oct call 2, 21 Oct ~9:50pm: 'Notify me' in the bar on every product).
     We add ONE button of our own to the bar ('Notify me', type=button, outside the product form) and set
     data-nsi-satc-mode="notify" on the bar while Notify me shows, so the first-paint CSS
     (snippets/nsi-wishlist-head.liquid) hides the bar's 'Sold out' button and its stepper and shows ours. A tap only
     brings Notify me's email field to the middle of the screen and focuses it (bisJump): it never clicks the real Add
     to cart, never submits the form and moves no option. The bar's own script and markup are never changed; its
     'Sold out' button keeps following the real one underneath. Notify mode needs the real Add to cart disabled, Notify
     me shown, and its email row there: after a sign-up for this option the bar says 'Sold out' again, as before.
     The wording stays 'if it comes back' (Andrew 20 Oct, call 1): the field's own label says it. Off switch / ?nsi_wl=0:
     this script doesn't run, so the bar is as it always was. */
  var satc = null, satcMo = null;
  function satcAdopt(bar) {
    if (satc) return true;
    var actions = bar && bar.querySelector('.nsi-satc__actions');
    if (!actions || !bar.querySelector('[data-satc-add]')) return false;
    var nb = D.createElement('button');
    nb.type = 'button';
    nb.className = 'nsi-satc__add nsi-satc__notify';
    nb.setAttribute('data-nsi-satc-notify', '');
    nb.textContent = T.satcNotify;
    actions.appendChild(nb);
    satc = { bar: bar, btn: nb };
    satcSync();
    return true;
  }
  function satcWatch() {
    if (satc || !satcBlock()) return;
    if (satcAdopt(D.querySelector('[data-nsi-satc]'))) return;
    if (!W.MutationObserver || satcMo || !D.body) return;
    /* the bar is appended to body after DOMContentLoaded, or once the real button and the price exist */
    try {
      satcMo = new W.MutationObserver(function () { if (satcAdopt(D.querySelector('body > [data-nsi-satc]'))) satcMo.disconnect(); });
      satcMo.observe(D.body, { childList: true });
      setTimeout(function () { try { satcMo.disconnect(); } catch (e) {} }, 20000);
    } catch (e) {}
  }
  function satcBlock() {   /* the main product form's Notify me block, or null */
    var w = D.querySelector('#shopify-section-static-product [data-nsi-wl-pdp]') || D.querySelector('[data-nsi-wl-pdp]');
    return w ? w.querySelector('[data-nsi-bis]') : null;
  }
  function satcSync() {
    if (!satc) return;
    /* the real Add to cart by its tag, class and type (never its data attribute: build.py keeps that out of our files);
       not found = no notify mode, so a working Add to cart is never hidden */
    var blk = satcBlock(), form = blk && blk.closest('form'), rb = form && form.querySelector('button.product-form--atc-button[type="submit"]');
    var row = blk && blk.querySelector('.nsi-bis__row'), on = false;
    try { on = !!(blk && !blk.hidden && blk.getClientRects().length && row && !row.hidden && rb && (rb.disabled || rb.classList.contains('disabled'))); } catch (e) { on = false; }
    var cur = satc.bar.getAttribute('data-nsi-satc-mode') === 'notify';
    if (on && !cur) satc.bar.setAttribute('data-nsi-satc-mode', 'notify');
    else if (!on && cur) satc.bar.removeAttribute('data-nsi-satc-mode');
  }
  /* the sticky bar's Notify me, or (release 2b) the stock line's 'Email me if it comes back' link: the email field to
     the middle of the screen, focused (a phone opens its keyboard); after a sign-up for this option, its thanks
     message instead. GA4 'nsi_bis_jump' {item_id, item_variant, from: 'sticky' | 'stock_line'}, a normal event */
  function bisJump(from) {
    var blk = satcBlock();
    if (!blk || blk.hidden) return false;
    var row = blk.querySelector('.nsi-bis__row'), input = blk.querySelector('[data-nsi-bis-email]');
    var to = row && !row.hidden && input ? input : (blk.querySelector('[data-nsi-bis-msg]') || blk);
    try { to.scrollIntoView({ block: 'center', inline: 'nearest' }); } catch (x) { try { to.scrollIntoView(); } catch (y) {} }
    if (to === input) { try { input.focus({ preventScroll: true }); } catch (x) { try { input.focus(); } catch (y) {} } }
    var vid = currentVariant(blk.closest('form')), P = productJson(), v = variantOf(P, vid);
    ga('nsi_bis_jump', { item_id: (v && v.sku) || String(vid || ''), item_variant: v && P && P.variants.length > 1 ? String(v.title || '') : '', from: from });
    return true;
  }

  /* ------------------------------------------------------------------ 'Email me my wishlist' (25 Oct 2026) */
  /* Andrew, 22 Oct 2026 (decisions.md 'Wishlist storage', "Second now", before Black Friday): on the wishlist page a
     shopper Klaviyo doesn't know yet can have a one-tap link to their list emailed to them. It opens the list on any
     device and outlives Safari's 7-day clean-out. sections/nsi-wishlist.liquid prints the box for guests only, and its
     placeholder script shows it before the first paint or not at all (see there): this script never shows it, it
     only sends.
     Fix round (Andrew 25 Oct 2026, decisions.md: "if they want their wishlist and us emailing it then they are auto
     subscribing to our emails and news and offers"): there is NO tick-box. The line printed above the field, before
     'Send link' (the box's words come from BOX-COPY.json through build.py), says the link comes with news and
     offers, so a send is the shopper's express consent, and a send always:
       1. signs the address up to WC | Newsletter (MAIL_LIST, single opt-in, custom_source 'Wishlist page'; its welcome
          flow follows) FIRST, so the consent is on record before the link's event: Klaviyo queues client calls, so
          this is the order we can give it (the event goes once the sign-up has answered, or after SUB_WAIT at most). A
          sign-up that fails (a 429 / 5xx / dropped connection) is tried once more on its own, 2 s later, and the link
          is sent either way;
       2. sends ONE Klaviyo client event, MAIL_EVENT, with the address on the profile (never klaviyo.identify, as
          everywhere in this file): Items / ItemCount / WishlistURL as the wishlist events carry them, WishlistItems
          (the link's entries alone, 'h' or 'h:v', comma-separated, for the email's own fixed
          https://www.nsinails.com.au link) and Source 'Wishlist page'. Klaviyo's flow 'NSI | Wishlist link' sends the
          one email. Since 27 Oct 2026 (decisions.md 27 Oct) Items are ONLY the saved entries this page view has seen
          live and in stock (inStock(), newest first, up to EV_MAX): the email shows their catalogue photo and title
          through lookups with unpublished="cancel", and Klaviyo skips the WHOLE email if one of them meets an item that
          can't be bought, so the box never names one. Round 7b (27 Oct 2026, review RV-2): ONE entry per product
          (onePerProduct(), after inStock(): the newest of a product's entries that can be bought), because the lookups
          are by product and three saved shades of one product showed three identical tiles. ItemCount (every saved
          entry) and WishlistItems (the link, sold out ones included) are unchanged; with nothing in stock Items is
          empty and the email shows no item: the button, with its fixed notes ('And more in your wishlist.' when more
          than 6 entries are saved, the 20-item note over 20).
     Guards: the honeypot (looks sent, sends nothing); one request in flight (busy, the button disabled; when the
     button had the focus, the status line takes it first, so it never falls to the page: RB-6); only an ?items=
     link still loading: 'Still loading your list' and nothing sent (RB-7); the same address and list again in this
     page view is never a second email; 3 sends an hour per browser (nsi_wl_mail_v1.h, like Notify me's throttle; in
     memory when storage is blocked); MAIL_MS (12 s) from the tap; a retry of the same address and list keeps its
     unique_id, so Klaviyo counts a lost answer once. A send stores the list's entry keys (nsi_wl_mail_v1.k), so the
     box stays away until something new is saved.
     Messages show in the status line under the field (the section reserves room for the tallest, so the box never
     changes size); the line before 'Send link' always stays. After a bad address the field is focused and
     aria-invalid; typing again clears the message.
     GA4, on the live theme only (Shopify.theme.role 'main', not the theme editor; anywhere else only logged, for
     checks): nsi_wl_email_shown once per page view (held until Google's tag is already loaded or the shopper first
     taps or types, like the nudge's) and nsi_wl_email_link after an accepted send, both {event_category: 'wishlist'},
     normal events.
     Off: the config's 'mail' key (build.py --no-mail, and --off), the master switch, ?nsi_wl=0. */
  var MAIL_KEY = 'nsi_wl_mail_v1', MAIL_PER_HOUR = 3, MAIL_LIST = 'XpD5BT', MAIL_EVENT = 'Requested Wishlist Link';
  var MAIL_MS = 12000, SUB_WAIT = 4000;   /* the whole send, from the tap; the most the link's event waits for the sign-up */
  var mail = null, mailMem = null;
  function mailLoad() {
    var s = parse(lsGet(MAIL_KEY));
    if (mailMem && !lsGet(MAIL_KEY)) s = mailMem;   /* storage blocked: this page view's own record */
    if (!s || s.v !== 1 || !Array.isArray(s.h) || !Array.isArray(s.k)) s = { v: 1, h: [], k: [] };
    var now = Date.now();
    s.h = s.h.filter(function (t) { return +t > 0 && now - t < HOUR && t - now < HOUR; });
    s.k = s.k.filter(function (x) { return typeof x === 'string' && /^\d{1,20}(?::\d{1,20})?$/.test(x); }).slice(0, MAX);
    return s;
  }
  function mailSave(s) { if (!lsSet(MAIL_KEY, JSON.stringify(s))) mailMem = s; }
  function liveTheme() { try { var S = W.Shopify; return !!(S && S.theme && S.theme.role === 'main' && !S.designMode); } catch (e) { return false; } }
  function gaLive(name, params, later) {   /* the box's GA4: the live theme only; anywhere else logged for checks */
    if (liveTheme()) { ga(name, params, later); return; }
    note('ga', { name: name, params: params, live: false });
  }
  function mailVisible() { try { return !!(mail && !mail.box.hidden && mail.box.getClientRects().length); } catch (e) { return false; } }
  function mailMsg(kind, text) {
    if (!mail) return;
    mail.msg.textContent = text || '';
    mail.msg.className = 'nsi-wl-mail__msg' + (kind ? ' nsi-wl-mail__msg--' + kind : '');
    if (kind) mail.box.setAttribute('data-nsi-wl-mail-state', kind); else mail.box.removeAttribute('data-nsi-wl-mail-state');
  }
  function mailInit() {
    var box = page && page.root.querySelector('[data-nsi-wl-mail]');
    var input = box && box.querySelector('[data-nsi-wl-mail-email]'), btn = box && box.querySelector('[data-nsi-wl-mail-send]');
    var msg = box && box.querySelector('[data-nsi-wl-mail-msg]');
    if (!box || !input || !btn || !msg) return;
    mail = { box: box, input: input, btn: btn, msg: msg, hp: box.querySelector('[data-nsi-wl-mail-hp]'), busy: false, done: {}, subOk: {}, subs: 0,
             uid: '', uidFor: '', shown: false };
    input.addEventListener('input', function () {   /* typing again clears an error or a 'Sent!' (never while sending) */
      if (mail.busy || !mail.box.hasAttribute('data-nsi-wl-mail-state')) return;
      input.removeAttribute('aria-invalid');
      mailMsg('', '');
    });
    if (mailVisible()) { mail.shown = true; gaLive('nsi_wl_email_shown', { event_category: 'wishlist' }, true); }
  }
  function mailSubmit() {
    if (!mail || mail.busy || !mailVisible()) return;
    var email = String(mail.input.value || '').trim();
    if (!validEmail(email)) {
      mailMsg('err', T.mailBad);
      mail.input.setAttribute('aria-invalid', 'true');
      try { mail.input.focus(); } catch (e) {}
      return;
    }
    mail.input.removeAttribute('aria-invalid');
    if (mail.hp && mail.hp.value) { note('mail', { honeypot: true }); mailMsg('ok', T.mailOk); return; }   /* a bot: look sent, send nothing */
    if (!items.length) { note('mail', { loading: true }); mailMsg('wait', T.mailWait); return; }   /* RB-7: only an ?items= link still loading */
    var lc = email.toLowerCase(), url = shareUrl(), same = lc + '|' + url;
    if (mail.done[same]) { note('mail', { repeat: true }); mailMsg('ok', T.mailOk); return; }   /* this link already went to this address in this page view: never a second email */
    if (mailLoad().h.length >= MAIL_PER_HOUR) { note('mail', { hourly: true }); mailMsg('err', T.mailHour); return; }
    if (mail.uidFor !== same) { mail.uid = 'nsiwl-l-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10); mail.uidFor = same; }
    var keys = items.map(function (x) { return ek(x.p, x.v); }), q = url.indexOf('?items=');
    var body = { data: { type: 'event', attributes: {
      properties: { Items: evItems(onePerProduct(inStock())), ItemCount: items.length, WishlistURL: url, WishlistItems: q < 0 ? '' : decodeURIComponent(url.slice(q + 7)), Source: 'Wishlist page' },
      metric: { data: { type: 'metric', attributes: { name: MAIL_EVENT } } },
      profile: { data: { type: 'profile', attributes: { email: email } } },
      unique_id: mail.uid } } };
    if (D.activeElement === mail.btn) { try { mail.msg.focus({ preventScroll: true }); } catch (e) {} }   /* RB-6: the status line keeps the focus, never the page */
    mail.busy = true;
    mail.btn.disabled = true;
    mail.box.setAttribute('aria-busy', 'true');
    mailMsg('busy', T.mailBusy);
    var ctl = W.AbortController ? new AbortController() : null, timer = ctl ? setTimeout(function () { ctl.abort(); }, MAIL_MS) : 0;
    var finish = function () { clearTimeout(timer); mail.busy = false; mail.btn.disabled = false; mail.box.removeAttribute('aria-busy'); };
    note('mail', { sending: true, count: items.length, uid: mail.uid });
    var went = false;
    var go = function () {   /* the link's event: once, after the sign-up has answered (or SUB_WAIT has passed) */
      if (went) return;
      went = true;
      klPost('events/', body, ctl && ctl.signal).then(function (r) {
        finish();
        note('mail', { status: r.status });
        if (r.status >= 200 && r.status < 300) {
          var st = mailLoad();
          st.h.push(Date.now()); st.k = keys.slice(0, MAX); mailSave(st);
          mail.done[same] = true;
          mailMsg('ok', T.mailOk);
          gaLive('nsi_wl_email_link', { event_category: 'wishlist' });
        } else if (r.status === 400) {
          mailMsg('err', T.mailBad2);
          mail.input.setAttribute('aria-invalid', 'true');
          try { mail.input.focus(); } catch (e) {}
        } else mailMsg('err', T.mailErr);
      }, function () {
        finish();
        note('mail', { status: 'network' });
        mailMsg('err', T.mailNet);
      });
    };
    if (mail.subOk[lc]) go();   /* signed up from this page view already (an earlier send failed after it): the link alone */
    else { setTimeout(go, SUB_WAIT); mailSubscribe(email, 0, go); }   /* the sign-up FIRST, then the link's event */
  }
  /* every send: WC | Newsletter, consent SUBSCRIBED, custom_source 'Wishlist page' (the line before 'Send link' says
     so). then: called once, with its answer or its failure; a failure is tried once more on its own, 2 s later */
  function mailSubscribe(email, tries, then) {
    var lc = email.toLowerCase();
    var body = { data: { type: 'subscription', attributes: { custom_source: 'Wishlist page',
      profile: { data: { type: 'profile', attributes: { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } } },
      relationships: { list: { data: { type: 'list', id: MAIL_LIST } } } } };
    var done = function () { if (then) { var f = then; then = null; f(); } };
    var again = function (why) {
      note('mail', { sub: why, tries: tries });
      if (tries < 1) setTimeout(function () { mailSubscribe(email, tries + 1, null); }, 2000);
      done();
    };
    mail.subs++;
    try {
      klPost('subscriptions/', body, null, true).then(function (r) {
        if (r.status === 429 || r.status >= 500) { again(r.status); return; }
        note('mail', { sub: r.status });
        if (r.status >= 200 && r.status < 300) mail.subOk[lc] = true;
        done();
      }, function () { again('network'); });
    } catch (e) { again('error'); }
  }

  /* ------------------------------------------------------------------ 'Share my wishlist' (27 Oct 2026) */
  /* Andrew, 27 Oct 2026 (decisions.md 27 Oct, ~9:40am): "the share my link link is very long, lets not have it in the
     email, just have it as a button on the website wishlist page where the button says share my wishlist and when they
     click it, it copys that long link they can email it or text it to someone". sections/nsi-wishlist.liquid prints
     the button (hidden) under the box, above the list, and its placeholder script shows it before the first paint
     whenever the page has a list (never later, so nothing moves; an emptied list hides it, data-n="0"): this script
     never shows or hides it, it only copies.
     A tap copies shareUrl(): the launch address with the 20 newest entries, 'h' or 'h:v', comma-separated and
     URL-encoded, exactly the box's WishlistURL (its WishlistItems encoded the same way the email's button link is), so
     whoever opens it sees the same list (the page's ?items= reader). navigator.clipboard.writeText is called straight
     from the tap (Safari needs that); without that API, or if it refuses, the read-only field under the button gets
     the link, focused and selected, and the browser's own copy command is tried: if it copies, the field goes again
     at once (it is never drawn) and focus is back on the button; if not, the field stays, selected, for the shopper
     to copy. The kit's toast then says 'Link copied' (or 'Copy the link below ...') for its 3.2 s, in its live
     region, so the page's layout never moves for a message. Only an ?items= link still loading (nothing saved yet):
     'Still loading your list ...' and nothing copied. Nothing else: no Klaviyo, no GA4, no storage, no request. */
  var share = null;
  function shareInit() {
    var row = page && page.root.querySelector('[data-nsi-wl-share]');
    var btn = row && row.querySelector('[data-nsi-wl-share-btn]'), field = row && row.querySelector('[data-nsi-wl-share-field]');
    if (!row || !btn || !field) return;
    share = { row: row, btn: btn, field: field, copies: 0, via: '', last: '' };
  }
  function shareDone(url, via) {
    share.copies++; share.via = via; share.last = url;
    note('share', { copied: via });
    toast(T.shareOk, false, null, null);
  }
  function shareField(url) {   /* the fallback: the link in the read-only field, selected; the browser's copy command tried */
    var f = share.field, ok = false;
    f.value = url;
    f.hidden = false;
    try { f.focus({ preventScroll: true }); } catch (e) { try { f.focus(); } catch (x) {} }
    try { f.select(); f.setSelectionRange(0, url.length); } catch (e) {}
    try { ok = D.execCommand('copy') === true; } catch (e) { ok = false; }
    if (ok) {   /* copied: the field goes again in the same task (never drawn), focus back on the button */
      f.hidden = true;
      f.value = '';
      try { share.btn.focus({ preventScroll: true }); } catch (e) {}
      shareDone(url, 'command');
      return;
    }
    share.via = 'field'; share.last = url;
    note('share', { field: true });
    toast(T.shareManual, false, null, null);
  }
  function shareCopy() {
    if (!share) return;
    if (!items.length) { note('share', { loading: true }); toast(T.shareWait, false, null, null); return; }   /* only an ?items= link still loading */
    var url = shareUrl(), clip = null, p = null;
    try { clip = W.navigator.clipboard; } catch (e) { clip = null; }
    if (clip && typeof clip.writeText === 'function') {
      try { p = clip.writeText(url); } catch (e) { p = null; }
    }
    if (p && typeof p.then === 'function') {
      p.then(function () { shareDone(url, 'clipboard'); }, function () { shareField(url); });
      return;
    }
    shareField(url);
  }
  function shareSync() {   /* a link left showing in the fallback field follows the list (its value only: nothing moves) */
    if (!share || share.field.hidden) return;
    var u = shareUrl();
    if (share.field.value !== u) share.field.value = u;
  }

  /* ------------------------------------------------------------------ wishlist page */
  var page = null, queued = {}, queue = [], active = 0, cardCache = {}, jsCache = {};
  /* entries from an ?items= link that are not saved here yet: {h, v, k: 'h' or 'h:v', t, inbound}, newest first.
     keepLink: one of them could not be stored (storage blocked), so the WHOLE parameter stays and a reload shows the
     list. failedLink (KS3-2, round 4; RV4-1, round 5): the keys of the entries whose card failed to load (the store
     refused it after the retries). Once every link entry has settled, ?items= is cut down to just those, in the link's
     order (narrowLink), so a reload tries them again but never re-adds an entry this view already merged (and the
     shopper may have removed since: review-4 K1). A deleted product ('gone') or a card without an id ('bad') is never
     kept. linkKept: what the address was cut down to (for checks). */
  var inbound = [], keepLink = false, failedLink = [], linkKept = null;
  /* 27 Oct 2026 (decisions.md 27 Oct): what this page view has learned of each saved entry's stock, from the card it
     loads anyway (no request of its own): stock['k' + 'p' or 'p:v'] = {ok, t}. ok: the card came back (the product is
     on the Online Store) and, by that card's own data (each variant's 'available', printed by the server then), the
     saved option can be bought, or for the product as a whole any of its options can. Round 7b (27 Oct 2026, the
     Klaviyo draft's review, RV-1): AND the product has at least one option that is available and not marked nsi_k 0.
     snippets/product-grid-item.liquid marks, on these card views only (recently_viewed), a variant Shopify sells only
     because its stock isn't tracked, with 'continue selling' off and its quantity at or below zero: Klaviyo's
     catalogue counts that variant as sold out, and a product with no other option in stock is 'unpublished' there, so
     its lookup skips the WHOLE email (27 Oct: the online Masterclass course, Shipping Insurance, GoGenerosity). Only
     the box's Items read it (inStock()), so the link email's catalogue lookups (unpublished="cancel") meet only
     products the catalogue has in stock, as far as this page view can know. Never stored or sent. An entry not loaded
     yet, or whose card failed, counts as not in stock, and what was learned STOCK_MS ago or more (a tab left open, a
     page restored by Back) no longer counts: the email then shows fewer items rather than risk a skipped link. Round
     7c (27 Oct 2026, the review of track K, K-RV-3): 'learned' is the card's own fetch time (getCard() stamps it as it
     asks, the cache keeps it with the card), never the moment place() runs, so a card re-placed from cardCache (another
     tab removed and re-added the entry, or saved another option of the product) counts only while its data is under
     STOCK_MS old. Still open: the catalogue's own sync (an item restocked moments before the send may still be sold
     out there). */
  var stock = {}, STOCK_MS = 18e5;
  function stockOf(vs, v) {
    var any = false, mine = !v;   /* mine: the saved option can be bought (the product as a whole: always) */
    for (var i = 0; i < vs.length; i++) {
      var x = vs[i];
      if (!x || typeof x !== 'object') continue;
      if (v && +x.id === +v) mine = x.available === true;
      if (x.available === true && x.nsi_k !== 0) any = true;   /* an option Klaviyo's catalogue has in stock */
    }
    return mine && any;
  }
  function inStock() {
    var now = Date.now();
    return items.filter(function (x) {
      var s = stock['k' + ek(x.p, x.v)];
      return !!(s && s.ok === true && now - s.t >= 0 && now - s.t < STOCK_MS);
    });
  }
  /* round 7b (27 Oct 2026, the Klaviyo draft's review, RV-2): the box's Items hold ONE entry per product, the first,
     so the newest of what inStock() kept: the email looks items up by product, so three saved shades of one product
     were three identical tiles. The list, ItemCount and WishlistItems are never touched. */
  function onePerProduct(list) {
    var seen = {};
    return list.filter(function (x) {
      if (seen['p' + x.p]) return false;
      seen['p' + x.p] = true;
      return true;
    });
  }
  function pageInit() {
    var root = D.querySelector('[data-nsi-wl-page]');
    if (!root) return;
    page = { root: root, grid: root.querySelector('[data-nsi-wl-grid]') };
    if (!page.grid) { page = null; return; }
    fromLink();
    pageRender();
    mailInit();   /* 25 Oct 2026: the 'Email me my wishlist' box (its first paint was the placeholder script's) */
    shareInit();   /* 27 Oct 2026: 'Share my wishlist' (its first paint, too, was the placeholder script's) */
  }
  function lk(h, v) { return h + (v ? ':' + v : ''); }   /* a link entry's key, as it is written in ?items= */
  /* ?items=: every entry checked, the invalid ones dropped, at most 20, each entry once (see the top of this file) */
  function linkItems() {
    var raw = null;
    try { raw = new URLSearchParams(location.search).get('items'); } catch (e) { return null; }
    if (raw === null) return null;
    var out = [], seen = {}, toks = String(raw).split(',', 200);
    for (var i = 0; i < toks.length && out.length < LINK_MAX; i++) {
      var m = ITEM.exec(toks[i]);
      if (!m || (m[2] && +m[2] > SAFE)) continue;
      var v = m[2] ? +m[2] : null, k = 'k' + lk(m[1], v);
      if (seen[k]) continue;
      seen[k] = 1;
      out.push({ h: m[1], v: v });
    }
    return out;
  }
  function fromLink() {
    var list = linkItems();
    if (list === null) return;
    var have = {}, fresh = [], t0 = Date.now();
    /* already saved, so it keeps its place: that option; for a plain handle, any entry of it */
    for (var i = 0; i < items.length; i++) { have['k' + lk(items[i].h, items[i].v)] = 1; have['h' + items[i].h] = 1; }
    list.forEach(function (x) { if (!have[x.v ? 'k' + lk(x.h, x.v) : 'h' + x.h]) fresh.push(x); });
    /* newer than anything saved, in the link's order, so they go first */
    inbound = fresh.map(function (x, i) { return { h: x.h, v: x.v, k: lk(x.h, x.v), t: t0 + fresh.length - i, inbound: true }; });
    note('items', { valid: list.length, fresh: inbound.length });
    if (!inbound.length) tidyLink();
  }
  function pending(k) { for (var i = 0; i < inbound.length; i++) if (inbound[i].k === k) return inbound[i]; return null; }
  function unpend(k) { inbound = inbound.filter(function (x) { return x.k !== k; }); }
  function tidyLink() {   /* take ?items= out of the address bar; every other parameter stays */
    try {
      var u = new URL(location.href);
      if (!u.searchParams.has('items') || !W.history || typeof W.history.replaceState !== 'function') return;
      u.searchParams.delete('items');
      var q = u.searchParams.toString();
      W.history.replaceState(W.history.state, '', u.pathname + (q ? '?' + q : '') + u.hash);
      note('items', { tidied: true });
    } catch (e) {}
  }
  function linkDone() {
    if (inbound.length || keepLink) return;   /* still loading, or storage blocked: the whole link stays */
    if (failedLink.length) narrowLink(failedLink); else tidyLink();
  }
  /* RV4-1 (round 5): ?items= cut down to the entries that failed, in the link's order (the same check as linkItems);
     every other parameter (utm_, Klaviyo's, view) and the hash stay. Nothing left: the address is tidied. */
  function narrowLink(keys) {
    try {
      var u = new URL(location.href), raw = u.searchParams.get('items');
      if (raw === null || !W.history || typeof W.history.replaceState !== 'function') return;
      var want = {}, keep = [], toks = String(raw).split(',', 200);
      for (var j = 0; j < keys.length; j++) want['k' + keys[j]] = 1;
      for (var i = 0; i < toks.length && keep.length < LINK_MAX; i++) {
        var m = ITEM.exec(toks[i]);
        if (!m || (m[2] && +m[2] > SAFE)) continue;
        var k = lk(m[1], m[2] ? +m[2] : null);
        if (want['k' + k]) { keep.push(k); want['k' + k] = 0; }
      }
      if (!keep.length) { tidyLink(); return; }
      u.searchParams.set('items', keep.join(','));
      var q = u.searchParams.toString();
      W.history.replaceState(W.history.state, '', u.pathname + (q ? '?' + q : '') + u.hash);
      linkKept = keep.slice();
      note('items', { narrowed: keep });
    } catch (e) {}
  }
  function slot(attr, val) {
    var li = D.createElement('li');
    li.className = 'nsi-wl-ph';
    li.setAttribute(attr, String(val));
    li.setAttribute('aria-hidden', 'true');
    li.innerHTML = '<div class="nsi-wl-ph__img"></div><div class="nsi-wl-ph__l"></div><div class="nsi-wl-ph__l nsi-wl-ph__l--s"></div>';
    return li;
  }
  function qk(it) { return it.inbound ? 'h' + it.k : 'p' + ek(it.p, it.v); }
  function enqueue(it) { var k = qk(it); if (!queued[k]) { queued[k] = 1; queue.push(it); } }
  function pageRender() {
    if (!page) return;
    var grid = page.grid, kids = [].slice.call(grid.children), have = {}, pend = {};
    kids.forEach(function (el) {
      var lkey = el.getAttribute('data-nsi-wl-pend');
      if (lkey !== null) {   /* a placeholder for a link entry that is still loading */
        if (!pending(lkey) || pend['k' + lkey]) grid.removeChild(el); else pend['k' + lkey] = el;
        return;
      }
      var k = el.getAttribute('data-nsi-wl-item') || el.getAttribute('data-nsi-wl-slot') || '';
      if (!byKey(k) || have['k' + k]) { grid.removeChild(el); return; }
      have['k' + k] = el;
    });
    /* newest first; link entries carry the newest times, before and after they are saved */
    var rows = inbound.concat(items).sort(byNewest);
    var els = rows.map(function (it) {
      var el;
      if (it.inbound) {
        el = pend['k' + it.k];
        if (!el) { el = slot('data-nsi-wl-pend', it.k); pend['k' + it.k] = el; }
        enqueue(it);
        return el;
      }
      var k = ek(it.p, it.v);
      el = have['k' + k];
      if (!el) { el = slot('data-nsi-wl-slot', k); have['k' + k] = el; }
      if (el.hasAttribute('data-nsi-wl-slot')) enqueue(it);
      return el;
    });
    var now = [].slice.call(grid.children);
    var same = els.length === now.length && els.every(function (el, i) { return now[i] === el; });
    if (!same) els.forEach(function (el) { grid.appendChild(el); });
    page.root.setAttribute('data-n', String(els.length));
    shareSync();
    pump();
  }
  function pump() {
    while (active < CAP && queue.length) {
      var it = queue.shift();
      if (it.inbound ? !pending(it.k) : !entry(it.p, it.v)) { delete queued[qk(it)]; continue; }
      active++;
      load(it);
    }
  }
  function handleFrom(u) { var m = /\/products\/([^\/?#]+)/.exec(u || ''); try { return m ? decodeURIComponent(m[1]) : ''; } catch (e) { return ''; } }
  function sameOrigin(u) { if (!u) return true; try { return new URL(u, location.href).origin === location.origin; } catch (e) { return false; } }
  function parseCard(html) {   /* the server card's <li>, parsed inert (no script runs, no image loads), or null */
    var tpl = D.createElement('template');
    tpl.innerHTML = typeof html === 'string' ? html : '';
    var li = tpl.content ? tpl.content.querySelector('li[data-product-item]') : null;
    return li && li.querySelector('article.productitem') ? li : null;
  }
  function wait(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  /* a server card: {gone: true} (404) or {html, h: the handle after a redirect, or '', at: when it was asked for (round
     7c: what its data says about stock is that old, however often the page re-places it)}. The product's own card
     (?view=_recently-viewed) is fetched ONCE per handle for all its product-level entries; a saved option's card
     (round 3, CARD_VIEW, its own price) once per price point of that product (pt: price|compare-at|stock), so
     options that print the same card share one fetch. Up to 2 retries on a 429, 1 on an error; a failure is
     forgotten, so a later render can try again. */
  function cardFor(h, v, pt) {
    var k = 'h' + h + (v ? '|' + pt : '');
    if (!cardCache[k]) {
      cardCache[k] = v ? optCard(h, v) : getCard(h, 0, 0);
      cardCache[k].then(null, function () { delete cardCache[k]; });
    }
    return cardCache[k];
  }
  /* the marker templates/product._nsi-wl-card.liquid prints before the card, with the option Shopify resolved */
  var VIEW_MARK = /<i hidden data-nsi-wl-view="1" data-v="(\d{0,20})"><\/i>/;
  /* one option's card from the option view. If the view didn't answer (no marker: the template isn't on this theme,
     e.g. a rollback or an old tab) or resolved another option, the product's own card, as before round 3. Round 4
     (P3-2): the same when the view fails outright (an error after getCard's retries: a 500, a dropped connection) or
     answers with its marker but no card in it, so a saved option is never missing from the page for the visit */
  function optCard(h, v) {
    return getCard(h, v, 0).then(function (res) {
      if (res.gone) return res;
      var html = String(res.html || ''), m = VIEW_MARK.exec(html.slice(0, 4096));
      var mine = !!(m && (m[1] === String(v) || m[1] === ''));   /* '' = not this product's option: its normal card */
      if (mine && parseCard(html)) return res;
      note('page', { h: h, v: v, view: !m ? 'missing' : (mine ? 'empty' : 'other:' + m[1]) });
      return cardFor(h);
    }, function () {
      note('page', { h: h, v: v, view: 'failed' });
      return cardFor(h);
    });
  }
  function getCard(h, v, tries) {
    var path = '/products/' + encodeURIComponent(h) + (v ? '?variant=' + v + '&view=' + CARD_VIEW : '?view=_recently-viewed');
    var at = Date.now();   /* round 7c (K-RV-3): when this card was asked for: the stock its data shows is no older */
    return W.fetch(path, { credentials: 'same-origin' }).then(function (r) {
      if (r.status === 404) return { gone: true };
      if (r.status === 429 && tries < 2) return { retry: 1500 * (tries + 1) };
      if (!r.ok) throw new Error('HTTP ' + r.status);
      /* a redirect (e.g. an admin URL redirect) that ends off this site is never parsed into the page */
      if (!sameOrigin(r.url)) { note('page', { h: h, offsite: true }); throw new Error('off-site'); }
      var h2 = r.redirected ? handleFrom(r.url) : '';
      return r.text().then(function (html) { return { html: html, h: h2, at: at }; });
    }).then(null, function (err) {
      if (tries < 1) return { retry: 2000 };
      throw err;
    }).then(function (res) {
      return res.retry ? wait(res.retry).then(function () { return getCard(h, v, tries + 1); }) : res;
    });
  }
  /* which card an entry shows: the product as a whole, its own card; one saved option of a product with several, that
     option's card, keyed by its price point from the product's .js (fetched anyway for the option's photo). An option
     that isn't the product's own, or a product with one option: the product's own card (the same figures). Round 4
     (RV3-4): the .js unreadable even after its retry: the product's own card too, ONCE per handle (the 'from' figure,
     never wrong for trade), instead of one option view per saved option (50 shades were 50 server renders, exactly
     when the store was refusing requests) */
  function cardOf(it) {
    if (!it.v) return cardFor(it.h);
    return productJs(it.h).then(function (d) {
      var vs = d && Array.isArray(d.variants) ? d.variants : null, x = vs ? variantOf(d, it.v) : null;
      if (!vs || !x || vs.length < 2) return cardFor(it.h);
      return cardFor(it.h, it.v, [+x.price || 0, +x.compare_at_price || 0, x.available ? 1 : 0].join('|'));
    });
  }
  /* /products/<handle>.js, ONCE per handle: a link entry's product id when its card has no Judge.me badge, and a
     saved option's own photo and price point. null when it can't be read. Round 4 (RV3-4): one retry on a 429, a 5xx
     or a dropped connection (after 1.5 s / 2 s, as getCard), never on a 404 or any other answer */
  function productJs(h) {
    var k = 'h' + h;
    if (!jsCache[k]) jsCache[k] = jsGet(h, 0).then(function (d) { return d && typeof d === 'object' ? d : null; }, function () { return null; });
    return jsCache[k];
  }
  function jsGet(h, tries) {
    return W.fetch('/products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin', headers: { accept: 'application/json' } }).then(function (r) {
      if ((r.status === 429 || r.status >= 500) && tries < 1) return wait(r.status === 429 ? 1500 : 2000).then(function () { return jsGet(h, tries + 1); });
      return r.ok && sameOrigin(r.url) ? r.json() : null;
    }, function (err) {
      if (tries < 1) return wait(2000).then(function () { return jsGet(h, tries + 1); });
      throw err;
    });
  }
  function variantPhoto(d, v) {   /* {src, alt} of an option's featured image in the product's .js, or null (none) */
    var vs = (d && d.variants) || [];
    for (var i = 0; i < vs.length; i++) {
      if (+vs[i].id !== +v) continue;
      var fi = vs[i].featured_image;
      return fi && typeof fi.src === 'string' ? { src: fi.src, alt: typeof fi.alt === 'string' ? fi.alt : '' } : null;
    }
    return null;
  }
  /* our own image hosts only (CR4, fix round 21 Oct 2026): Shopify's CDN, or the store's own /cdn/shop/ path on
     www.nsinails.com.au or this page's host; never any other host, whatever its path. Round 4 (P3-1 / RV3-5): the
     path is judged as the browser resolves it, new URL(...).pathname with its dot segments resolved, and a path with
     '..' or '%2e' (any case) anywhere is refused outright: '/cdn/shop/../../x.jpg' and its %2e%2e form used to pass */
  function ownImage(host, path) {
    var hh = String(host || '').toLowerCase(), raw = String(path || '/').split(/[?#]/)[0], pn = '';
    if (/\.\.|%2e/i.test(raw)) return false;
    if (hh === 'cdn.shopify.com') return true;
    if (hh !== 'www.nsinails.com.au' && hh !== String(location.host || '').toLowerCase()) return false;
    try { pn = new URL(raw, 'https://' + hh).pathname; } catch (e) { return false; }
    return pn.indexOf('/cdn/shop/') === 0 && raw.indexOf('/cdn/shop/') === 0;
  }
  /* FX5 (round 3): the same check for what an entry stores (i) and what Klaviyo gets (ImageURL, Items[].ImageURL): a
     full https URL on our own image hosts, unchanged, else '' */
  function ownUrl(u) {
    var s = typeof u === 'string' ? u : '', m = /^https:\/\/([^\/?#\s"'<>\\]+)(\/[^\s"'<>\\]*)?$/i.exec(s);
    return m && s.length <= 600 && ownImage(m[1], m[2] || '/') ? s : '';
  }
  /* a Shopify image URL as the theme's rimg template ('//host/.../name_{size}.jpg?v=..'), its own sizing taken off;
     from our own image hosts only (ownImage), else '' */
  function rimgTemplate(u) {
    var m = /^(?:https?:)?\/\/([^\/?#\s"'<>\\]+)(\/[^?#\s"'<>\\]+?)(?:_\d*x\d*)?(\.(?:jpe?g|png|gif|webp))(\?[^#\s"'<>\\]*)?$/i.exec(String(u || ''));
    if (!m || !ownImage(m[1], m[2])) return '';
    var q = (m[4] || '').replace(/[?&](?:width|height|crop)=[^&]*/g, '').replace(/^&/, '?');
    return '//' + m[1] + m[2] + '_{size}' + m[3] + q;
  }
  /* a saved option's own photo on its card, in the theme's rimg form (so the theme's lazy loader and lazyFallback load
     it); the hover photo goes, as it shows another option or the product. Once per card. */
  function swapPhoto(li, ph) {
    var img = li && li.querySelector('img.productitem--image-primary'), tpl = ph && rimgTemplate(ph.src);
    if (!img || !tpl || li.__nsiPhoto) return false;
    li.__nsiPhoto = true;
    var lazy = (img.getAttribute('srcset') || '').indexOf('data:image/svg') === 0;
    img.setAttribute('src', tpl.replace('{size}', '384x384'));
    if (img.hasAttribute('data-rimg-template')) img.setAttribute('data-rimg-template', tpl);
    if (!lazy) img.setAttribute('srcset', tpl.replace('{size}', '384x384') + ' 1x, ' + tpl.replace('{size}', '768x768') + ' 2x');
    if (ph.alt) img.setAttribute('alt', ph.alt);
    [].forEach.call(li.querySelectorAll('img.productitem--image-alternate'), function (x) { x.parentNode.removeChild(x); });
    return true;
  }
  /* which photo a saved option's card shows: its featured image from the .js (null: it has none, so the card's own is
     right); if the .js could not be read, the one saved with it (i), unless that is the card's own photo anyway */
  function photoFor(li, o, cur) {
    if (o.photo !== undefined) return o.photo;
    var mine = cur && cur.i ? rimgTemplate(cur.i) : '', img = li.querySelector('img.productitem--image-primary');
    var own = img ? String(img.getAttribute('data-rimg-template') || '').replace(/^https?:/, '') : '';
    return mine && mine !== own ? { src: cur.i, alt: '' } : null;
  }
  function load(it) {
    cardOf(it).then(function (res) {
      if (res.gone) return res;
      var o = { li: parseCard(res.html), h: res.h, at: res.at };   /* round 7c: the card's own fetch time, for its stock */
      o.p = it.inbound ? (o.li ? cardId(o.li) : 0) : it.p;
      var photo = !!(o.li && manyHas(o.li, it.v));   /* a saved option of a product with several: its own photo */
      if (!o.li || (o.p && !photo)) return o;
      return productJs(res.h || it.h).then(function (d) {
        if (!o.p) o.p = (d && id(d.id)) || 0;   /* a link entry whose card has no Judge.me badge */
        if (photo && d) { o.photo = variantPhoto(d, it.v); o.on = optName(d); }   /* its photo; its one option's name */
        return o;
      });
    }).then(function (o) {
      active--;
      delete queued[qk(it)];
      if (it.inbound) { takeIn(it, o); pump(); return; }
      if (o.gone) { note('page', { k: ek(it.p, it.v), gone: true }); removeEntry(it.p, it.v); pump(); return; }   /* deleted or unpublished: drop quietly (no event) */
      var cur = entry(it.p, it.v);
      if (cur && o.h && o.h !== cur.h && HANDLE.test(o.h)) { cur.h = o.h; persist(); }   /* handle changed (redirect) */
      place(it, o);
      pump();
    }, function () {
      active--;
      delete queued[qk(it)];
      if (it.inbound) { if (failedLink.indexOf(it.k) === -1) failedLink.push(it.k); dropIn(it.k, 'failed'); pump(); return; }   /* never saved; RV4-1 (round 5): ?items= keeps just the failed entries, so a reload tries them again */
      var s = page && page.grid.querySelector('[data-nsi-wl-slot="' + ek(it.p, it.v) + '"]');
      if (s) s.parentNode.removeChild(s);   /* keep it saved; it tries again next visit */
      note('page', { k: ek(it.p, it.v), failed: true });
      pump();
    });
  }
  /* a link entry's card has loaded: save it (no event: nothing was added by the shopper) and show the card */
  function takeIn(it, o) {
    if (!pending(it.k)) return;
    if (o.gone) { dropIn(it.k, 'gone'); return; }   /* deleted or unpublished: dropped quietly, never saved */
    var li = o.li, p = o.p;
    if (!li || !p) { dropIn(it.k, 'bad'); return; }
    var data = cardJson(li), vs = (data && data.variants) || [], v = null;
    for (var i = 0; i < vs.length; i++) if (it.v && +vs[i].id === it.v) v = it.v;   /* only the product's own variant */
    /* saved here already (perhaps under another handle): that entry stays. The product as a whole counts as saved
       when any of its options is. */
    if (entry(p, v) || (!v && entriesOf(p).length)) { dropIn(it.k, 'saved'); return; }
    if (v && vs.length > 1) swapPhoto(li, photoFor(li, o, null));   /* before the email snapshot reads the photo */
    var e = snap(cardSnap(li, { v: v }), { h: o.h && HANDLE.test(o.h) ? o.h : it.h, p: p, v: v, t: it.t });
    unpend(it.k);
    var s = page && page.grid.querySelector('[data-nsi-wl-pend="' + it.k + '"]');
    if (s) { s.removeAttribute('data-nsi-wl-pend'); s.setAttribute('data-nsi-wl-slot', ek(p, v)); }
    items = clean([e].concat(items));
    if (!persist()) keepLink = true;
    note('items', { h: it.h, p: p, v: v, saved: true });
    if (s) place(e, o);   /* the card already fetched: no second request */
    changed();
    linkDone();
  }
  function dropIn(k, why) {
    unpend(k);
    note('items', { k: k, dropped: why });
    pageRender();   /* takes its placeholder out and recounts (the empty state shows if nothing is left) */
    linkDone();
  }
  function place(it, o) {
    if (!page) return;
    var k = ek(it.p, it.v), cur = entry(it.p, it.v);
    var s = page.grid.querySelector('[data-nsi-wl-slot="' + k + '"]');
    if (!s || !cur) return;
    var li = o && o.li, art = li && li.querySelector('article.productitem');
    if (!li || !art) { s.parentNode.removeChild(s); note('page', { k: k, bad: true }); return; }
    var jid = cardId(li);   /* the card's own product id: a reused handle must not show another product */
    if (jid && jid !== it.p) { note('page', { k: k, other: jid }); removeEntry(it.p, it.v); return; }
    var data = cardJson(li), vs = (data && data.variants) || [], pick = null;
    for (var i = 0; i < vs.length; i++) if (it.v && +vs[i].id === +it.v) pick = vs[i];
    stock['k' + k] = { ok: stockOf(vs, it.v), t: +o.at || 0 };   /* 27 Oct 2026: for the box's Items (inStock()). Round 7c (K-RV-3): t = when the card was fetched, never now: a card re-placed from the cache keeps its age */
    var opt = !!(pick && vs.length > 1);   /* a saved option of a product with several: its own photo */
    if (opt) swapPhoto(li, photoFor(li, o, cur));
    var fresh = cardSnap(li, cur);   /* read after the photo swap, before the card is changed below */
    if (opt && o.photo === undefined && !li.__nsiPhoto) delete fresh.i;   /* its photo unknown: keep the one saved with it */
    var hdr = li.querySelector('.product-recently-viewed-card-time');
    if (hdr) hdr.parentNode.removeChild(hdr);
    li.classList.remove('product-recently-viewed-card');
    li.removeAttribute('data-recently-viewed-card');
    li.classList.add('nsi-wl-item');
    li.setAttribute('data-nsi-wl-item', k);
    var vt = '';
    if (opt) {
      [].forEach.call(li.querySelectorAll('a[data-product-page-link]'), function (a) {
        var href = a.getAttribute('href') || '';
        if (href && href.indexOf('variant=') === -1) a.setAttribute('href', href + (href.indexOf('?') === -1 ? '?' : '&') + 'variant=' + pick.id);
      });
      vt = variantTitle(pick);
      var h2 = li.querySelector('.productitem--title');
      if (vt && vt !== 'Default Title' && h2) {
        var pv = D.createElement('p');
        pv.className = 'nsi-wl-variant';
        pv.textContent = optLine(vt, o && o.on) + (pick.available ? '' : ' · Sold out');   /* '005' -> 'Colour: 005' */
        h2.parentNode.insertBefore(pv, h2.nextSibling);
      } else vt = '';
    }
    var tl = li.querySelector('.productitem--title a');
    var title = tl ? tl.textContent.replace(/\s+/g, ' ').trim() : '';
    var rm = D.createElement('button');
    rm.type = 'button';
    rm.className = 'nsi-wl-remove';
    rm.setAttribute('data-nsi-wl-remove', '');
    rm.setAttribute('data-nsi-wl-p', String(it.p));
    if (it.v) rm.setAttribute('data-nsi-wl-v', String(it.v));
    rm.setAttribute('aria-label', 'Remove ' + (title || 'this product') + (vt ? ' ' + vt : '') + ' from wishlist');
    rm.textContent = 'Remove';
    art.appendChild(rm);
    [].forEach.call(li.querySelectorAll('.jdgm-prev-badge[data-number-of-reviews]'), function (b) {
      if (+b.getAttribute('data-number-of-reviews') > 0) b.style.display = '';   /* Judge.me unhides badges on load only */
    });
    s.parentNode.replaceChild(li, s);
    try { li.dispatchEvent(new CustomEvent('theme:rimg:watch', { bubbles: true })); } catch (e) {}
    setTimeout(function () { lazyFallback(li); }, 2500);
    if (refreshSnap(entry(it.p, it.v), fresh)) persistSoon();   /* what the emails show for it, from the server card */
  }
  function lazyFallback(li) {
    /* the theme's rimg script normally swaps the placeholder in; if it did not, use the 384px image it rendered */
    [].forEach.call(li.querySelectorAll('img[data-rimg="lazy"]'), function (img) {
      var ss = img.getAttribute('srcset') || '';
      if (ss.indexOf('data:image/svg') !== 0) return;
      var tpl = img.getAttribute('data-rimg-template') || '';
      if (tpl) img.setAttribute('srcset', tpl.replace('{size}', '384x384') + ' 1x, ' + tpl.replace('{size}', '768x768') + ' 2x');
      else img.removeAttribute('srcset');
    });
  }
  function pageRemove(btn) {
    var p = +attr(btn, 'data-nsi-wl-p'), v = +attr(btn, 'data-nsi-wl-v') || 0, it = entry(p, v);
    if (!it) return;
    var li = btn.closest('[data-nsi-wl-item]');
    var info = pageInfo(li, it);
    var next = li && (li.nextElementSibling || li.previousElementSibling);
    removeEntry(p, v);
    klaviyoEvent('Removed from Wishlist', info);
    var f = next && next.querySelector('[data-nsi-wl-remove]');
    if (!f && page) f = page.root.querySelector('.nsi-wl-page__btn');
    if (f) { try { f.focus({ preventScroll: true }); } catch (e) { f.focus(); } }
  }

  /* ------------------------------------------------------------------ wiring */
  D.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var b = t.closest('[data-nsi-wl-toggle]');
    if (b) { e.preventDefault(); toggle(b, e); return; }
    var nb = t.closest('[data-nsi-wl-nudge-save]');
    if (nb) { e.preventDefault(); nudgeSave(nb, e); return; }
    var un = t.closest('[data-nsi-wl-undo]');
    if (un) { e.preventDefault(); undo(); return; }
    var r = t.closest('[data-nsi-wl-remove]');
    if (r) { e.preventDefault(); pageRemove(r); return; }
    var sj = t.closest('[data-nsi-satc-notify]');
    if (sj) { e.preventDefault(); bisJump('sticky'); return; }   /* round 5: never the real Add to cart */
    var lj = t.closest('[data-nsi-bis-jump]');
    if (lj) { if (bisJump('stock_line')) e.preventDefault(); return; }   /* release 2b; without Notify me the link's own #anchor */
    var ms = t.closest('[data-nsi-wl-mail-send]');
    if (ms) { e.preventDefault(); mailSubmit(); return; }   /* 25 Oct 2026: 'Email me my wishlist' */
    var sh = t.closest('[data-nsi-wl-share-btn]');
    if (sh) { e.preventDefault(); shareCopy(); return; }   /* 27 Oct 2026: 'Share my wishlist' (straight from the tap) */
    var n = t.closest('[data-nsi-bis-submit]');
    if (n) { e.preventDefault(); bisSubmit(n.closest('[data-nsi-bis]')); }
  });
  D.addEventListener('change', function (e) {
    var t = e.target;
    if (t && t.name === 'id' && t.closest && t.closest('[data-product-form]')) scheduleSync();
  }, true);
  D.addEventListener('nsi:variant-price', scheduleSync);
  var jqBound = false;
  function bindJq() {
    if (jqBound || !W.jQuery) return;
    jqBound = true;
    try { W.jQuery(W).on('shopify-variants:switch-variant.nsi-wl', scheduleSync); } catch (e) {}
  }

  function init() {
    nudgeInit();   /* first: it reads the box the header's first-paint style gave the nudge, before paintAll removes it */
    paintAll();
    watchGrids();
    if (D.querySelector('[data-nsi-wl-pdp]')) {
      bisSync();
      satcWatch();   /* round 5: the phone sticky bar (built by snippets/product.liquid after DOMContentLoaded) */
      bindJq();
      if (!jqBound) W.addEventListener('load', bindJq);
    }
    pageInit();
  }

  W.NSIWishlist = {
    version: '2026-10-27c',
    items: function () { return items.map(function (x) { return { h: x.h, p: x.p, v: x.v, t: x.t }; }); },
    count: function () { return items.length; },
    has: function (p, v) { return v === undefined ? entriesOf(p).length > 0 : !!entry(p, v); },
    paint: paintAll,
    _paintCount: function (n) { paintCount(n == null ? items.length : n); },   /* checks only: paints, never writes */
    info: function () {
      var w = D.querySelector('[data-nsi-wl-pdp]'), blk = w && w.querySelector('[data-nsi-bis]');
      var bt = w && w.querySelector('[data-nsi-wl-toggle]');
      return { count: items.length, storage: lsGet(KEY) !== null, pdpVariant: w ? currentVariant(w.closest('form')) : null,
               pdpSaved: bt ? isSaved(bt) : null, bisShown: blk ? !blk.hidden : null, page: !!page, queued: queue.length,
               active: active, inbound: inbound.map(function (x) { return x.k; }), keepLink: keepLink, undo: !!undoBox,
               failedLink: failedLink.slice(), linkKept: linkKept, satc: satc ? { mode: satc.bar.getAttribute('data-nsi-satc-mode') || '' } : null,
               key: KEY, fromV1: fromV1, numbers: NAME_NUMBERS, toastHeld: toastHeld(), toastTimer: !!toastTimer,
               nudge: nudge ? { reserved: nudge.reserved, state: nudge.state, done: nudge.done, sent: nudge.sent, inView: nudge.inView, visits: nudge.visits } : null,
               mail: mail ? { shown: mail.shown, visible: mailVisible(), busy: mail.busy, sent: Object.keys(mail.done).length, live: liveTheme(),
                              state: mail.box.getAttribute('data-nsi-wl-mail-state') || '', subs: mail.subs, subOk: Object.keys(mail.subOk).length } : null,
               share: share ? { copies: share.copies, via: share.via, last: share.last, field: !share.field.hidden } : null,
               inStock: page ? inStock().map(function (x) { return ek(x.p, x.v); }) : null,
               stockKnown: page ? Object.keys(stock).map(function (k) { return [k.slice(1), stock[k].ok]; }) : null,
               email: !!customerEmail(), log: log.slice() };
    }
  };

  if (D.readyState === 'loading') D.addEventListener('DOMContentLoaded', init);
  else init();
})();
